// noinspection JSUnresolvedVariable,JSJQueryEfficiency,JSCheckFunctionSignatures,HtmlRequiredAltAttribute

const HASH_VERSION = 2;
const HASH_NUM_BLOCKS = 8;
const HASH_BASE_INFO_NUM_ENTRIES = 8;
const HASH_MIN_NUM_ACTIONBARS = 2;
const HASH_NUM_ACTIONBAR_SLOTS = 6;
const HASH_NUM_SET_MIN_FIELDS = 2;
const HASH_BUILD_INTERVAL = 150;

const INPUT_MODE_INPUT = 'input';
const INPUT_MODE_READONLY = 'readonly';
const INPUT_MODE_HASH = 'hash';

const SEPERATOR_BLOCK = ';';
const SEPERATOR_DATA = ',';
const SEPERATOR_PAIR = ':';

const ATTRIBUTES_MAX_POINTS = 64;
const CHAMP_SPEEDUP_TRIGGER_INTERVAL = 500;
const CHAMP_SPEEDUP_INTERVAL = 80;
const ATTRIBUTE_SPEEDUP_TRIGGER_INTERVAL = 500;
const ATTRIBUTE_SPEEDUP_INTERVAL = 80;

const CHAMP_DISCIPLINE_GREEN_ID = 1;
const CHAMP_DISCIPLINE_BLUE_ID = 2;
const CHAMP_DISCIPLINE_RED_ID = 3;

const CHAMP_POINT_SPENT_TYPE_ADD = 1;
const CHAMP_POINT_SPENT_TYPE_REMOVE = 2;

const CHAMP_TOOLTIP_TYPE_SKILL = 1;
const CHAMP_TOOLTIP_TYPE_CHAMPION = 2;
const CHAMP_TOOLTIP_TYPE_CHAMPION_CLUSTER = 3;
const CHAMP_TOOLTIP_TYPE_CHAMPION_BAR_SLOT = 4;
const CHAMP_CLUSTER_OFFSET_X = 49;
const CHAMP_CLUSTER_OFFSET_Y = 49;
const CHAMP_CLUSTER_POINTS_OFFSET_X = 27;
const CHAMP_CLUSTER_POINTS_OFFSET_Y = 64;
const CHAMP_STAR_OFFSET_X = 49;
const CHAMP_STAR_OFFSET_Y = 49;
const CHAMP_STAR_ACTION_OFFSET_X = 49;
const CHAMP_STAR_ACTION_OFFSET_Y = 2;
const CHAMP_CLUSTER_ICON = '/assets/images/cp-20/cluster.png';
const CHAMP_DRAG_TYPE_SKILL = 1;
const CHAMP_DRAG_TYPE_SLOT = 2;
const CHAMP_BAR_SLOT_INDEX_MIN = 1;
const CHAMP_BAR_SLOT_INDEX_MAX = 12;
const CHAMP_BAR_SLOT_HTML = '<span class="slotted champ_bar_slotted" data-slot="1" draggable="true"></span>';
const SLOT_EMPTY_DATA_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

const SET_TYPES = [
  { type: 'head', query_index: 1 },
  { type: 'shoulders', query_index: 2 },
  { type: 'hand', query_index: 3 },
  { type: 'chest', query_index: 4 },
  { type: 'waist', query_index: 5 },
  { type: 'legs', query_index: 6 },
  { type: 'feet', query_index: 7 },
  { type: 'neck', query_index: 8 },
  { type: 'ring1', query_index: 9 },
  { type: 'ring2', query_index: 10 },
  { type: 'bar1', group_slot: 'main-hand', query_index: 11 },
  { type: 'bar1', group_slot: 'off-hand', query_index: 12 },
  { type: 'bar2', group_slot: 'main-hand', query_index: 13 },
  { type: 'bar2', group_slot: 'off-hand', query_index: 14 },
  { type: 'bar1_poison', is_poison: true, query_index: 15 },
  { type: 'bar2_poison', is_poison: true, query_index: 16 },
]
const SET_WEAPON_TYPES_BLOCKING_OFF_HAND = [
  4, // Two handed Sword
  5, // Two handed Axe
  6, // Two handed Hammer
  8, // Bow
  9, // Healing Staff
  12, // Fire Staff
  13, // Frost Staff
  15, // Lightning Staff
];

const ALWAYS_ACTIVE_SKILLS = {
  146: 1,
}

const bodyObj = $('body');
const inputGlobalHashObj = $('#skillPlanerHashGlobal');
const saveBtn = $('#saveBtn');
const shareLink = $('#shortLink');
const shareBox = $('#skillPlanerOptions');
const factionDropDown = $('#factionDropDown');
const factionDropDownContent = $('#factionDropDownContent');
const raceDropDown = $('#raceDropDown');
const raceDropDownContent = $('#raceDropDownContent');
const classDropDown = $('#classDropDown');
const classDropDownContent = $('#classDropDownContent');
const mundusDropDown = $('#mundusDropDown');
const mundusDropDownContent = $('#mundusDropDownContent');
const createShortLinkObj = $('#createShortLink');
const tooltip = $('#skillTooltip');
const specFav = $('#specFav');
const factionSelectObj = $('img.select_faction, li.select_faction');
const raceSelectObj = $('img.select_race, li.select_race');
const classSelectObj = $('img.select_class, li.select_class');
const mundusSelectObj = $('img.select_mundus, li.select_mundus');
const passiveSkillList = $('#passiveSkillList');
const passiveSkillListEmpty = $('#passiveSkillListEmpty');
const champLoadingObj = $('#champFullLoading');
const champPrev = $('a.champ_prev');
const champNext = $('a.champ_next');
const champDisciplineInfoPanel = $('#champDisciplineInfoPanel');
const champDisciplineName = $('#champDisciplineName');
const champDisciplinePointsImg = $('#champDisciplinePointsImg');
const champTreePointsObj = $('#champTreePoints');
const setSelect = $('[data-set-type="set"]');
const setDataSelect = $('[data-set-type]:not([data-set-type="set"])');
const setWeaponTypeSelect = $('[data-set-type="weapon-type"][data-set-group-slot="main-hand"]');
const setWeaponTypeOffHandSelect = $('[data-set-type="weapon-type"][data-set-group-slot="off-hand"]');
const tabSkills = $('#tabSkills');
const tabSets = $('#tabSets');
const panelSkills = $('#panelSkillPlaner');
const panelSets = $('#panelSets');
const tabChampionSystem = $('#tabChampionSystem');
const panelChampionSystem = $('#panelChampionSystem');
const panelChampionSystemFull = $('#panelChampionSystemFull');
const panelChampionSystemPreview = $('#panelChampionSystemPreview');
const champConnectors = $('#champConnectors');
const activeSetsListObj = $('#activeSetsList');
const champBack = $('#champBack');
const champSlotBar = $('div.camp_slot_bar_section');
const skillTotalPoints = $('#totalPoints');

let skills = {};
let skillsActive = {};
let skillsUltimate = {};
let querySkills = {};
let tooltipCache = {};
let inGameRaces = {};
let inGameClasses = {};
let champSkills = {};
let champActiveSkills = {};
let champPointsPerDiscipline = {};
let champLinkedSkills = {};
let champSkillData = {};
let champTempActiveSkills;
let champTempCheckedActiveSkills;
let activeSets = [];

let skillFaction = 0;
let skillClass = 0;
let skillRace = 0;
let skillMundus = 0;
let attrMagicka = 0;
let attrHealth = 0;
let attrStamina = 0;
let totalPoints = 0;
let champCurrentDisciplineId = 0;
let champCurrentParentDisciplineId = 0;
let totalChampPoints = 0;

let inputMode = INPUT_MODE_HASH;
let inputModeObj = null;
let buildHashTimeout = null;
let tooltipVisible = false;
let shortLinkXHR = null;
let tooltipXHR = null;
let tooltipX = 0;
let tooltipY = 0;
let favXHR = null;
let saveBtnBaseUri = '';
let championDisciplineXHR = null;
let champSpeedup = null;
let champTriggerSpeedup = null;
let setHasMythicSlotted = false;
let champDragObj = null;
let champDragType = null;
let attributeSpeedup = null;
let attributeTriggerSpeedup = null;


// Document ready
(function() {

  panelSets.addClass('hidden');

  let raceCount = $('[data-race]').length;
  let classCount = $('[data-class]').length;

  // Get language entries
  for(let r = 1; r <= raceCount; r++) {
    inGameRaces[r] = $('[data-race="' + r + '"]').attr('title');
  }
  for(let c = 1; c <= classCount; c++) {
    inGameClasses[c] = $('[data-class="' + c + '"]').attr('title');
  }

  // Always active skills
  for(let k in ALWAYS_ACTIVE_SKILLS) {
    skillsActive[k] = ALWAYS_ACTIVE_SKILLS[k];
  }

  // Build planer mode: "hash" or "input"
  if(typeof skillPlanerMode !== 'undefined') {

    // Modus: Input
    if(skillPlanerMode === INPUT_MODE_INPUT) {

      // Werte setzen
      inputMode = INPUT_MODE_INPUT;
      inputModeObj = $('#skillPlanerHash');

      // Hash Parsen wenn vorhanden
      if(inputModeObj.val() !== '') {
        parseHash(inputModeObj.val());
      }
    }

    // Modus: Read Only
    else if(skillPlanerMode === INPUT_MODE_READONLY) {

      // Werte setzen
      inputMode = INPUT_MODE_READONLY;
      inputModeObj = $('#skillPlanerHash');

      // Hash Parsen wenn vorhanden
      if(inputModeObj.val() !== '') {
        parseHash(inputModeObj.val());
      }
    }
  }

  // Modus: Hash
  else {

    // Set base Uri for save buttons
    saveBtnBaseUri = saveBtn.data('base-uri');
    inputMode = INPUT_MODE_HASH;

    if(window.location.hash !== '') {
      parseHash(window.location.hash);
    }
  }

  if(inputMode === INPUT_MODE_READONLY) {
    $('#champInfotext').hide();
  }

  setAttrPoints();

  shareLink.val(window.location.href);

  if(window.location.hash !== '') {
    saveBtn.addData('url', saveBtnBaseUri + encodeURI(btoa(window.location.hash.substring(1))));
  }

  factionDropDown.on('click', function() {

    raceDropDownContent.hide();
    classDropDownContent.hide();
    mundusDropDownContent.hide();

    if(factionDropDownContent.is(':visible') === true) {
      factionDropDownContent.hide();
    }
    else {
      factionDropDownContent.show();
    }
  });

  raceDropDown.on('click', function() {

    factionDropDownContent.hide();
    classDropDownContent.hide();
    mundusDropDownContent.hide();

    if(raceDropDownContent.is(':visible') === true) {
      raceDropDownContent.hide();
    }
    else {
      raceDropDownContent.show();
    }
  });

  classDropDown.on('click', function() {

    factionDropDownContent.hide();
    raceDropDownContent.hide();
    mundusDropDownContent.hide();

    if(classDropDownContent.is(':visible') === true) {
      classDropDownContent.hide();
    }
    else {
      classDropDownContent.show();
    }
  });

  mundusDropDown.on('click', function() {

    factionDropDownContent.hide();
    raceDropDownContent.hide();
    classDropDownContent.hide();

    if(mundusDropDownContent.is(':visible') === true) {
      mundusDropDownContent.hide();
    }
    else {
      mundusDropDownContent.show();
    }
  });

  createShortLinkObj.on('click', function() { createShortLink(); });

  // Tab wechseln
  tabSkills.on('click', function() {
    tabSkills.removeClass('active').addClass('active');
    tabChampionSystem.removeClass('active');
    tabSets.removeClass('active');
    panelChampionSystem.hide();
    panelSets.hide();
    panelSkills.show();
    requestBuildHash();
  });
  tabChampionSystem.on('click', function() { activateChampionTab(null); });
  tabSets.on('click', function() {
    tabSets.removeClass('active').addClass('active');
    tabSkills.removeClass('active');
    tabChampionSystem.removeClass('active');

    panelSkills.hide();
    panelChampionSystem.hide();
    panelSets.show();
  });

  $('img.champ_preview').on('click', function() {
    if($(this).attr('id') !== '') {
      initChampionTree($(this).data('id'));
    }
  });

  champPrev.on('click', function() {
    initChampionTree($(this).data('tree-id'));
  });

  champNext.on('click', function() {
    initChampionTree($(this).data('tree-id'));
  });

  bodyObj.on('click', '[data-cluster]', function() {
    initChampionTree($(this).data('id'));
  });

  champBack.on('click', function() {
    let backDisciplineId = champBack.data('discipline-id');
    if(backDisciplineId !== null) {
      initChampionTree(parseInt(backDisciplineId))
    }
    else {
      showChampionOverview();
    }
  });

  // Save current value on open select
  setSelect.on('chosen:showing_dropdown', function() {
    let obj = $(this);
    obj.addData('current-value', obj.val());
  });

  setSelect.on('change', function() {
    onSetSelected(this, null, null);
    requestBuildHash();
    setBuildActiveList();
  });

  setDataSelect.on('change', function() {
    requestBuildHash();
  });
  setWeaponTypeSelect.on('change', function() { onSetWeaponTypeSelected(this, null, null); });
  setWeaponTypeOffHandSelect.on('change', function() { onSetWeaponTypeOffHandSelected(this, null, null); });

  bodyObj.on('click', '#activeSetsList > li > span', function() {
    tabSets.trigger('click');
  });

  initChampionDragAndDrop();
  setBuildActiveList();

  // Build final hash to save it to the input and avoid override by the weapon select methods
  if(typeof skillPlanerMode !== 'undefined' && skillPlanerMode === INPUT_MODE_INPUT) {
    requestBuildHash();
  }

  if(window.location.hash !== '') {
    if(window.location.hash === '#show:sets') {
      tabSets.click();
    }
    else if(window.location.hash === '#show:cp') {
      tabChampionSystem.click();
    }
  }
})();

/**
 * Place the tooltip to the cursor position.
 */
bodyObj.on('mousemove', 'img.skill_icon, img.skill_icon_static, img.skill_tooltip_trigger, img.cs_skill_tooltip_trigger, img.cs_cluster_skill_tooltip_trigger, img.champ_plus, img.champ_minus, .champ_bar_slotted', function(e) {

  tooltipX = e.pageX;
  tooltipY = e.pageY;

  if(tooltipVisible === true) {

    let thisObj = $(this);
    let tooltipType = getTooltipDataType(thisObj);
    let tooltipPosX = e.pageX;

    // If tooltip is on the right side
    // Mouse position + Tooltip width + Offset
    if((tooltipX + tooltip.width() + 120) > $(window).width()) {
      tooltipPosX = tooltipX - (tooltip.width() + 150);
    }

    // For champion skills, place tooltip near the cursor
    if(tooltipType === CHAMP_TOOLTIP_TYPE_CHAMPION || tooltipType === CHAMP_TOOLTIP_TYPE_CHAMPION_BAR_SLOT || tooltipType === CHAMP_TOOLTIP_TYPE_CHAMPION_CLUSTER) {
      tooltipPosX -= 68;
    }

    tooltip.css({
      'left': tooltipPosX + 'px',
      'top': tooltipY + 'px'
    });
  }
});

/**
 * Show tooltip on mouse enter event.
 */
bodyObj.on('mouseenter', 'img.skill_icon, img.skill_icon_static, img.cs_skill_tooltip_trigger, img.cs_cluster_skill_tooltip_trigger, img.skill_tooltip_trigger, img.champ_plus, img.champ_minus, .champ_bar_slotted', function() {

  tooltipVisible = true;

  let thisObj = $(this);
  let tooltipType = getTooltipDataType(thisObj);
  let fastLoad = false;
  let tooltipDataId;
  let tooltipDataPoints = 0;

  if(tooltipType === CHAMP_TOOLTIP_TYPE_CHAMPION) {
    tooltipDataId = parseInt(thisObj.data('id'));
    tooltipDataPoints = getChampionStarPoints(tooltipDataId);
  }
  else if(tooltipType === CHAMP_TOOLTIP_TYPE_CHAMPION_BAR_SLOT) {
    tooltipType = CHAMP_TOOLTIP_TYPE_CHAMPION;
    tooltipDataId = parseInt(thisObj.parent().data('skill-id'));

    if(champSkills.hasOwnProperty(tooltipDataId) === true) {
      tooltipDataPoints = getChampionStarPoints(tooltipDataId);
    }
  }
  else {
    tooltipDataId = thisObj.data('id');
    tooltipDataPoints = thisObj.data('points');
  }

  if(thisObj.hasClass('champ_plus') === true || thisObj.hasClass('champ_minus') === true) {
    tooltipDataId = parseInt(thisObj.data('id'));
    tooltipDataPoints = getChampionStarPoints(tooltipDataId);
    fastLoad = true;
  }

  getTooltip(tooltipDataId, tooltipDataPoints, tooltipType, fastLoad);
});

/**
 * Hide tooltips on mouse leave event.
 */
bodyObj.on('mouseleave', 'img.skill_icon, img.skill_icon_static, img.skill_tooltip_trigger, img.cs_skill_tooltip_trigger, img.cs_cluster_skill_tooltip_trigger, img.champ_plus, img.champ_minus, .champ_bar_slotted', function() {
  tooltip.hide();
  tooltipVisible = false;
});

/**
 * The mouse down event for champion skills.
 */
bodyObj.on('mousedown', 'img.champ_plus, img.champ_minus', function(event) {

  if(inputMode !== INPUT_MODE_READONLY) {

    if (champTriggerSpeedup !== null) {
      clearTimeout(champTriggerSpeedup);
    }
    if (champSpeedup !== null) {
      clearTimeout(champSpeedup);
    }

    let skillObj = $(this);
    let spentType = (skillObj.hasClass('champ_plus') === true) ? CHAMP_POINT_SPENT_TYPE_ADD : CHAMP_POINT_SPENT_TYPE_REMOVE;

    // Jump to next unlock points
    if(event.shiftKey === true) {

      if (spentType === CHAMP_POINT_SPENT_TYPE_ADD) {
        addChampionPoint(skillObj, false, true);
      }
      else {
        removeChampionPoint(skillObj, false, true);
      }
    }

    // Regular points spent method
    else {

      if (spentType === CHAMP_POINT_SPENT_TYPE_ADD) {
        addChampionPoint(skillObj, true, false);
      }
      else {
        removeChampionPoint(skillObj, true, false);
      }

      // Speedup trigger after holding the mouse button for x seconds
      champTriggerSpeedup = setTimeout(function() {
        champSpeedup = setTimeout(function() {
          if (skillObj.hasClass('champ_plus') === true) {
            addChampionPoint(skillObj, true, false);
          }
          else {
            removeChampionPoint(skillObj, true, false);
          }
        }, CHAMP_SPEEDUP_INTERVAL);
      }, CHAMP_SPEEDUP_TRIGGER_INTERVAL);
    }
  }
});

/**
 * The mouse up/leave event for champion skills.
 */
bodyObj.on('mouseleave', 'img.champ_plus, img.champ_minus', null, stopChampSpeedup);
bodyObj.on('mouseup', 'img.champ_plus, img.champ_minus', null, stopChampSpeedup);

/**
 * The mouse up/leave event for attributes.
 */
bodyObj.on('mouseleave', 'img.attr_toggle', null, stopAttributeSpeedup);
bodyObj.on('mouseup', 'img.attr_toggle', null, stopAttributeSpeedup);

/**
 * The the attributes button is clicked.
 */
bodyObj.on('mousedown', 'img.attr_toggle', function() {

  if(inputMode !== INPUT_MODE_READONLY) {

    // Timeouts löschen
    if (attributeTriggerSpeedup !== null) {
      clearTimeout(attributeTriggerSpeedup);
    }
    if (attributeSpeedup !== null) {
      clearTimeout(attributeSpeedup);
    }

    let attrId = $(this).attr('id');

    changeAttribute(attrId);

    // Speedup Trigger nach x Sekunden halten
    attributeTriggerSpeedup = setTimeout(function() {
      attributeSpeedup = setTimeout(function() {
        changeAttribute(attrId);
      }, ATTRIBUTE_SPEEDUP_INTERVAL);
    }, ATTRIBUTE_SPEEDUP_TRIGGER_INTERVAL);
  }
});

/**
 * Disable the right click context menü for the champion bar.
 */
bodyObj.on('contextmenu', '.champ_slot_bar', function(event) {
  event.preventDefault();
  return false;
});

/**
 * Clear the champion bar slot with a right click.
 */
bodyObj.on('mousedown', '.champ_bar_slotted', function(event) {

  if(event.buttons === 2) {

    let slot = $(this.parentElement);
    slot.html('');
    slot.deleteData('skill-id');
    delete champActiveSkills[slot.data('bar')];

    // Hide tooltip
    tooltip.hide();
    tooltipVisible = false;

    requestBuildHash();
  }
});

/**
 * Add or remove build from users bookmarks
 */
specFav.on('click', function() {

  let oldContent = specFav.html();

  specFav.html('<i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;Lade...');

  if(favXHR !== null) {
    favXHR.abort();
  }

  favXHR = $.ajax({
    type: 'POST',
    dataType: 'json',
    url: '/ajax/set_favourite.php',
    data: { lang: lang, id: specFav.data('id') }
  });

  favXHR.done(function(json) {

    if(json.error === 0) {
      specFav.html(json.msg);
    }
    else {
      showStaticTooltip(null, specFav, '<i class="fa fa-info-circle"></i>&nbsp;&nbsp;' + json.msg, 3000, 978, 'center red');
      specFav.html(oldContent);
    }
  });

  favXHR.always(function() {
    favXHR = null;
  });
});

/**
 * Set faction active when the user clicks a class object.
 */
factionSelectObj.on('click', function() {
  if(inputMode !== INPUT_MODE_READONLY) {
    setFaction($(this).data('faction'));
    requestBuildHash();
  }
});

/**
 * Set race active when the user clicks a class object.
 */
raceSelectObj.on('click', function() {
  if(inputMode !== INPUT_MODE_READONLY) {
    setRace($(this).data('race'));
    requestBuildHash();
  }
});

/**
 * Set class active when the user clicks a class object.
 */
classSelectObj.on('click', function() {
  if(inputMode !== INPUT_MODE_READONLY) {
    setClass($(this).data('class'));
    requestBuildHash();
  }
});

/**
 * Set mundus active when the user clicks a class object.
 */
mundusSelectObj.on('click', function() {
  if(inputMode !== INPUT_MODE_READONLY) {
    setMundus($(this).data('mundus'));
    requestBuildHash();
  }
});

/**
 * Start save action when the save button was clicked.
 */
saveBtn.on('click', function() {
  window.location.href = $(this).data('url');
});


/**
 * Toggle the category if the user clicks on it.
 */
$('span.category_header').on('click', function() {
  $('#category' + $(this).data('id')).toggle('fast');
});

/**
 * Show skills if the user click on a skilltree name.
 */
$('li.skilltree_name').on('click', function() {

  let ultimateObj = $('#skillTreeUltimate' + $(this).data('id'));
  let activeObj = $('#skillTreeActive' + $(this).data('id'));
  let passiveObj = $('#skillTreePassive' + $(this).data('id'));

  $('img.skill_icon[data-skilltree-id="' + $(this).data('id') + '"], img.skill_icon_static[data-skilltree-id="' + $(this).data('id') + '"]').each(function(key, value) {
    $(value).attr('src', $(value).data('icon'));
  });

  // Set skilltree name
  $('#skillTreeName').html($(this).data('name'));

  // Toggle elements
  $('#skillInfoText').hide();
  $('div.skill_list').hide();
  ultimateObj.show();
  activeObj.show();
  passiveObj.show();

  // Toggle ultimate skill display
  if(ultimateObj.children().length > 0) {
    $('div.ultimate').show();
  }
  else {
    $('div.ultimate').hide();
  }

  // Toggle active skill display
  if(activeObj.children().length > 0) {
    $('div.active').show();
  }
  else {
    $('div.active').hide();
  }

  // Toggle passive skill display
  if(passiveObj.children().length > 0) {
    $('div.passive').show();
  }
  else {
    $('div.passive').hide();
  }
});

/**
 * Activate skill when the user clicks a skill.
 */
$('img.skill_icon').on('mousedown', function(event) {

  if(inputMode !== INPUT_MODE_READONLY) {

    let obj = $(this);
    let objParent = $('img.skill_icon[data-id="' + obj.data('parent') + '"]');
    let objStaticParent = null;
    let objMorph = null;
    let status = false;
    let noParentPoints = false;
    let skillPoints;

    // Set default button if no button type set
    if(typeof event.button === 'undefined') {
      event.button = 0;
    }

    // Left click - Add point
    if(event.button === 0) {

      // Morph Berechtigung prüfen
      if(obj.data('parent') > 0) {

        // Andren Morph prüfen, es darf immer nur
        // ein Morph aktiv sein
        objMorph = $('img.skill_icon[data-id="' + obj.data('morph-id') + '"]');

        // Es sind keine Punkte im anderen Morph
        if(objMorph.data('points') === 0) {

          // Parent Objekte ermitteln
          // Wenn Punkte für das Objekt deaktiviert sind
          // dann wird nur auf die Existenz geprüft
          objParent = $('img.skill_icon[data-id="' + obj.data('parent') + '"]');
          objStaticParent = $('img.skill_icon_static[data-id="' + obj.data('parent') + '"]');

          // Prüfen ob Punkte im Parent sind
          if((objStaticParent.length > 0 || objParent.data('points') > 0) && obj.data('points') < obj.data('points-max')) {
            status = true;
          }
          else if(objParent.data('points') < 1) {
            noParentPoints = true;
          }
        }
      }

      // Aktive / Passive Fähigkeit prüfen
      else if(obj.data('points') < obj.data('points-max')) {
        status = true;
      }

      // Aktiviere Parent Skill bei Morph Klick
      if(noParentPoints === true && typeof objMorph !== 'undefined') {
        // noinspection JSObjectNullOrUndefined,JSUnresolvedFunction
        $('img.skill_icon[data-id="' + objMorph.data('parent') + '"]').trigger('mousedown');
        status = true;
      }

      // Punkte dürfen geändert werden
      if(status === true) {

        // Maximale Punktzahl ist nicht erreicht
        // maxPoints is set in HTML script tag
        // noinspection JSUnresolvedVariable
        if((totalPoints + 1) <= maxPoints) {
          totalPoints++;
          obj.addData('points', obj.data('points') + 1);
          $(this).css('opacity', OPACITY_ACTIVE);
        }
        else {
          // noinspection JSUnresolvedVariable
          alert(langArr['build_planer.max_skill_points_spent']);
        }
      }
    }

    // Right click - Remove point
    else if(event.button === 2) {

      if(obj.data('points') > obj.data('points-min')) {

        obj.addData('points', obj.data('points') - 1);

        // Style ändern
        if(obj.data('points') === obj.data('points-min')) {

          // Parent wieder hinzufügen
          if(obj.data('parent') > 0) {

            // Parent nur hinzufügen wenn Punkte verteilt werden können
            if(objParent.data('points-enabled') === 1) {
              querySkills[obj.data('parent')] = '1';
            }

            if(obj.data('skill-type') === 'active') {
              skillsActive[obj.data('parent')] = '1';
            }
            else if(obj.data('skill-type') === 'ultimate') {
              skillsUltimate[obj.data('parent')] = '1';
            }
          }

          resetMorphs(obj.data('id'));

          // Style deaktivieren wenn nicht immer aktiviert
          if(obj.data('points-min') === 0) {
            $(this).css('opacity', OPACITY_INACTIVE);
          }

          // Morph-Verzweigung anpassen
          switch(obj.data('type')) {
            case 'parent':
              $('li.morph_tree[data-parent="' + obj.data('id') + '"]').attr('class', 'unselectable morph_tree morph_tree_disabled');
              break;

            case 'morph1':
              // noinspection JSJQueryEfficiency
              if($('img.skill_icon[data-id="' + obj.data('morph-id') + '"]').data('points') === 0) {
                $('li.morph_tree[data-morph-1="' + obj.data('id') + '"]').attr('class', 'unselectable morph_tree');
              }
              break;

            case 'morph2':
              // noinspection JSJQueryEfficiency
              if($('img.skill_icon[data-id="' + obj.data('morph-id') + '"]').data('points') === 0) {
                $('li.morph_tree[data-morph-2="' + obj.data('id') + '"]').attr('class', 'unselectable morph_tree');
              }
              break;
          }
        }

        totalPoints--;
      }
    }

    // If points spent
    if(obj.data('points') > obj.data('points-min')) {

      // Morph Verzweigung wechseln
      switch(obj.data('type')) {
        case 'parent':

          let childrenPoints = 0;

          // Punkte der Kindelemente abfragen
          $('img[data-parent="' + obj.data('id') + '"]').each(function(key, value) {
            if($(value).data('points') > 0) {
              childrenPoints++;
            }
          });

          // Beide Zweige aktivieren wenn keine Punkte in Unterelementen vorhanden sind
          if(childrenPoints === 0) {
            $('li.morph_tree[data-parent="' + obj.data('id') + '"]').attr('class', 'unselectable morph_tree');
          }
          break;

        case 'morph1':
          $('li.morph_tree[data-morph-1="' + obj.data('id') + '"]').attr('class', 'unselectable morph_tree morph_tree_up');
          break;

        case 'morph2':
          $('li.morph_tree[data-morph-2="' + obj.data('id') + '"]').attr('class', 'unselectable morph_tree morph_tree_down');
          break;
      }

      // Skill initialisieren
      if(typeof skills[obj.data('id')] === 'undefined') {
        skills[obj.data('id')] = 0;
      }
      if(typeof querySkills[obj.data('id')] === 'undefined') {
        querySkills[obj.data('id')] = 0;

        if(obj.data('skill-type') === 'active') {
          skillsActive[obj.data('id')] = 1;
        }
        else if(obj.data('skill-type') === 'ultimate') {
          skillsUltimate[obj.data('id')] = 1;
        }
      }

      // Punkte zuweisen
      skills[obj.data('id')] = obj.data('points');
      querySkills[obj.data('id')] = obj.data('points');

      if(obj.data('skill-type') === 'active') {
        skillsActive[obj.data('id')] = 1;
      }
      else if(obj.data('skill-type') === 'ultimate') {
        skillsUltimate[obj.data('id')] = 1;
      }

      // Parent ist zwangsweise aktiviert, darum entfernen
      if(obj.data('parent') > 0) {
        delete querySkills[obj.data('parent')];

        if(obj.data('skill-type') === 'active') {
          delete skillsActive[obj.data('parent')];
        }
        else if(obj.data('skill-type') === 'ultimate') {
          delete skillsUltimate[obj.data('parent')];
        }
      }

      if(obj.data('skill-type') === 'passive') {
        addPassiveList(obj);
      }
    }

    // No points spent
    else if(obj.data('points') === obj.data('points-min')) {

      // Punkte löschen
      delete skills[obj.data('id')];
      delete querySkills[obj.data('id')];

      if(obj.data('skill-type') === 'active') {
        delete skillsActive[obj.data('id')];
      }
      else if(obj.data('skill-type') === 'ultimate') {
        delete skillsUltimate[obj.data('id')];
      }
      else if(obj.data('skill-type') === 'passive') {
        removePassiveList(obj);
      }
    }

    // Hide share box if no points are spent
    if(totalPoints === 0 && totalChampPoints === 0 && isSetPieceActive() === false) {
      shareBox.hide();
    }

    skillPoints = ((obj.data('points') > obj.data('points-min')) ? obj.data('points') : '1');

    getTooltip(obj.data('id'), skillPoints, CHAMP_TOOLTIP_TYPE_SKILL, false);

    $('span.skill_icon_count[data-id="' + obj.data('id') + '"]').html(obj.data('points') + '/' + obj.data('points-max'));

    requestBuildHash();
  }
});


/**
 * Gets the tooltip data type.
 *
 * @param {object} obj The DOM object.
 * @returns {number} Returns the tooltip data type.
 */
function getTooltipDataType(obj) {

  let dataType;

  if(obj.hasClass('cs_skill_tooltip_trigger') === true) {
    dataType = CHAMP_TOOLTIP_TYPE_CHAMPION;
  }
  else if(obj.hasClass('cs_cluster_skill_tooltip_trigger') === true) {
    dataType = CHAMP_TOOLTIP_TYPE_CHAMPION_CLUSTER;
  }
  else if(obj.hasClass('champ_bar_slotted') === true) {
    dataType = CHAMP_TOOLTIP_TYPE_CHAMPION_BAR_SLOT;
  }
  else {
    dataType = CHAMP_TOOLTIP_TYPE_SKILL;
  }

  return dataType;
}

/**
 * Inits the champion drag and drop functionality.
 */
function initChampionDragAndDrop() {

  bodyObj.on('dragstart touchstart', function(event) {

    champDragObj = $(event.target);

    // Hide tooltip
    tooltip.hide();
    tooltipVisible = false;

    // Slot bar move
    if(typeof champDragObj.data('slot') !== 'undefined' && champDragObj.data('slot') === 1) {
      champDragType = CHAMP_DRAG_TYPE_SLOT;
    }

    // Champion skill move
    else {
      champDragType = CHAMP_DRAG_TYPE_SKILL;
      champSlotBar.removeClass('slot_active');
      $('div.camp_slot_bar_section[data-bar-type="' + champDragObj.data('bar-type') + '"]').addClass('slot_active');
    }
  });

  bodyObj.on('drop', function(event) {

    event.preventDefault();

    let slot;

    if(champDragType === CHAMP_DRAG_TYPE_SKILL) {

      slot = $(event.target);

      if(slot.hasClass('slotted') === true) {
        slot = slot.parent();
      }

      if(slot.hasClass('champ_slot') === true && slot.data('bar-type') === champDragObj.data('bar-type')) {

        // Remove same skill if added again
        let sameSlots = $('[data-bar][data-skill-id="' + champDragObj.data('id') + '"]');
        if(sameSlots.length > 0) {
          sameSlots.each(function(k, v) {
            removeChampionSkillFromTopBar(parseInt(v.dataset.skillId));
          });
        }

        slot.addData('skill-id', champDragObj.data('id'));
        slot.html(CHAMP_BAR_SLOT_HTML);

        champActiveSkills[slot.data('bar')] = champDragObj.data('id');
      }
    }
    else {

      slot = champDragObj.parent();
      slot.deleteData('skill-id');
      slot.html('');

      delete champActiveSkills[slot.data('bar')];
    }

    requestBuildHash();
  });

  bodyObj.on('dragend', function() {

    if(champDragType === CHAMP_DRAG_TYPE_SKILL) {
      champSlotBar.removeClass('slot_active');
    }

    champDragObj = null;
    champDragType = null;
  });

  bodyObj.on('dragover', function(event) {
    event.preventDefault();
  });
}

/**
 * Handles the selected event for set selects.
 */
function onSetSelected(handle, data, overrideObject) {

  let obj
  if(overrideObject !== null && typeof overrideObject === 'object') {
    obj = overrideObject;
  }
  else {
    obj = $(handle);
  }

  const isPoison = isPoisonObject(obj);
  const groupType = obj.data('set-group');
  const setId = parseInt(obj.val());
  const currentValue = parseInt(obj.data('current-value'));

  if(setId !== currentValue) {
    removeSetFromActiveList(currentValue);
  }

  if(setId > 0) {

    let selectedObj = obj.children('option:selected');
    let elementGroupSelector = '';

    addSetToActiveList(setId);

    // Update armor types for selected set
    if(obj.data('set-has-armor-type') === 1) {

      elementGroupSelector = '[data-set-group="' + groupType + '"]';

      let armorTypeSelect = $(elementGroupSelector + '[data-set-type="armor-type"]');
      let selectedVal = armorTypeSelect.has(':selected').val();
      let activeArmorTypes = 0;
      let onlyActiveArmorType = 0;

      if(selectedObj.data('armor-light') === 1) {
        activeArmorTypes++;
        onlyActiveArmorType = 1;
      }
      if(selectedObj.data('armor-medium') === 1) {
        activeArmorTypes++;
        onlyActiveArmorType = 2;
      }
      if(selectedObj.data('armor-heavy') === 1) {
        activeArmorTypes++;
        onlyActiveArmorType = 3;
      }

      // Reset armor type if the currently selected value is not supported for the selected set
      if(selectedVal === '1' && selectedObj.data('armor-light') !== 1) {
        armorTypeSelect.val(0);
      }
      if(selectedVal === '2' && selectedObj.data('armor-medium') !== 1) {
        armorTypeSelect.val(0);
      }
      if(selectedVal === '3' && selectedObj.data('armor-heavy') !== 1) {
        armorTypeSelect.val(0);
      }

      // Select the only available option
      if(activeArmorTypes === 1) {
        armorTypeSelect.val(onlyActiveArmorType);
      }

      let armorLightAvailable = (selectedObj.data('armor-light') === 1);
      let armorMediumAvailable = (selectedObj.data('armor-medium') === 1);
      let armorHeavyAvailable = (selectedObj.data('armor-heavy') === 1);
      let armorNumAvailable = armorLightAvailable + armorMediumAvailable + armorHeavyAvailable;

      armorTypeSelect.children('option[data-set-armor-type-light]').prop('disabled', (armorLightAvailable === false));
      armorTypeSelect.children('option[data-set-armor-type-medium]').prop('disabled', (armorMediumAvailable === false));
      armorTypeSelect.children('option[data-set-armor-type-heavy]').prop('disabled', (armorHeavyAvailable === false));

      let disableArmorFirstOption = (armorNumAvailable === 1);

      armorTypeSelect.children('[value="0"]').prop('disabled', disableArmorFirstOption);
      armorTypeSelect.trigger("chosen:updated");

      disableChosenSelect(elementGroupSelector + ':not([data-set-type="set"])', false);
    }

    // Update weapon types for selected set
    if(obj.data('set-has-weapon-type') === 1) {

      let weaponSlot = obj.data('set-group-slot');

      elementGroupSelector = '[data-set-group="' + groupType + '"][data-set-group-slot="' + weaponSlot + '"]';

      let weaponTypeSelect = $(elementGroupSelector + '[data-set-type="weapon-type"]');
      let selectedVal = weaponTypeSelect.has(':selected').val();
      let weaponTypes = String(selectedObj.data('weapon-types')).split(',');
      let weaponTypesCount = 0;

      weaponTypeSelect.find('option').each(function() {

        if(this.value === "0") {
          return;
        }

        let disabled = true;
        if($.inArray(this.value, weaponTypes) !== -1) {
          disabled = false;
          weaponTypesCount++;
        }

        weaponTypeSelect.children('option[value="' + this.value + '"]').prop('disabled', disabled);
      });

      if($.inArray(selectedVal, weaponTypes) === -1) {
        weaponTypeSelect.val(0);
      }

      // Select the only available option
      if(weaponTypes.length === 1) {
        weaponTypeSelect.val(weaponTypes[0]);

        // Trigger selected event for manual change for main hand weapon type select
        onSetWeaponTypeSelected(null, null, weaponTypeSelect);
        onSetWeaponTypeOffHandSelected(null, null, weaponTypeSelect);
      }

      weaponTypeSelect.children('[value="0"]').prop('disabled', (weaponTypesCount === 1));
      weaponTypeSelect.trigger("chosen:updated");
      disableChosenSelect(elementGroupSelector + ':not([data-set-type="set"])', false);
    }

    let qualitySelectObj = $(elementGroupSelector + '[data-set-type="quality"]');

    if(isPoison === false) {

      // Enable mythic quality
      if (selectedObj.data('mythic') === 1) {

        qualitySelectObj.children('option').each(function(k, v) {
          v.disabled = (parseInt(v.value) !== 6);
        });
        qualitySelectObj.val(6);
        setHasMythicSlotted = true;

        setSelect.children('option[data-mythic]').prop('disabled', true);
        setSelect.children(elementGroupSelector + ' > option[value="' + setId + '"]').prop('disabled', false);
      }

      // Disable mythic quality
      else {
        qualitySelectObj.children('option').each(function(k, v) {
          v.disabled = (parseInt(v.value) === 6);
        });

        if (isMythicSetPieceActive() === false && setHasMythicSlotted === true) {
          qualitySelectObj.val(0);
          setSelect.children('option[data-mythic]').prop('disabled', false);
          setHasMythicSlotted = false;
        }
      }
    }

    setSelect.trigger('chosen:updated');
    qualitySelectObj.trigger('chosen:updated');
  }
  else {

    if(obj.data('set-has-armor-type') === 1) {
      $('[data-set-group="' + groupType + '"]:not([data-set-type="set"])').val(0);
      disableChosenSelect('[data-set-group="' + groupType + '"]:not([data-set-type="set"])', true);
    }

    if(obj.data('set-has-weapon-type') === 1) {
      let weaponSlot = obj.data('set-group-slot');
      $('[data-set-group="' + groupType + '"][data-set-group-slot="' + weaponSlot + '"]:not([data-set-type="set"])').val(0);
      disableChosenSelect('[data-set-group="' + groupType + '"][data-set-group-slot="' + weaponSlot + '"]:not([data-set-type="set"])', true);

      // Trigger selected event for manual change for main hand weapon type select
      onSetWeaponTypeSelected(null, null, $('[data-set-group="' + groupType + '"][data-set-group-slot="main-hand"][data-set-type="weapon-type"]'));
      onSetWeaponTypeOffHandSelected(null, null, $('[data-set-group="' + groupType + '"][data-set-group-slot="off-hand"][data-set-type="weapon-type"]'));
    }

    if(isMythicSetPieceActive() === false && setHasMythicSlotted === true) {
      setSelect.children('option[data-mythic]').prop('disabled', false);
      setSelect.trigger('chosen:updated');
      setHasMythicSlotted = false;
    }
  }
}

/**
 * Checks if a set piece is active.
 *
 * @returns {boolean} Returns True if a set piece is active otherwise False.
 */
function isSetPieceActive() {

  let status = false;
  setSelect.find('option:selected').each(function(k, v) {
    if(v.value > 0) {
      status = true;
      return false;
    }
  });

  return status;
}

/**
 * Checks if a mythic set piece is active.
 *
 * @returns {boolean} Returns True if a mythic set piece is active otherwise False.
 */
function isMythicSetPieceActive() {

  let status = false;
  setSelect.find('option:selected').each(function(k, v) {
    if(v.value > 0 && v.dataset.hasOwnProperty('mythic') === true) {
      status = true;
      return false;
    }
  });

  return status;
}

/**
 * Gets the is poison status for the slot.
 *
 * @param {int} slot The slot number.
 * @returns {boolean} Returns True if the slot is a poison slot otherwise False.
 */
function isPoisonSlot(slot) {

  let status = false;

  for(let x = 0; x < SET_TYPES.length; x++) {
    if(SET_TYPES[x].query_index === slot) {
      if(typeof SET_TYPES[x].is_poison !== 'undefined') {
        status = true;
        break;
      }
    }
  }

  return status;
}

/**
 * Gets the poison status for the given select element.
 *
 * @param {object} obj The select object.
 * @returns {boolean} Returns True if the object is a poison object otherwise False.
 */
function isPoisonObject(obj) {
  return (obj.data('set-poison') === 1);
}

/**
 * Handles the weapon type selected event.
 */
function onSetWeaponTypeSelected(handle, data, overrideObject) {

  let obj
  if(overrideObject !== null && typeof overrideObject === 'object') {
    obj = overrideObject;
  }
  else {
    obj = $(handle);
  }

  let groupType = obj.data('set-group');
  let objValue = parseInt(obj.val());

  if(objValue > 0 && $.inArray(objValue, SET_WEAPON_TYPES_BLOCKING_OFF_HAND) !== -1) {
    let offHandObj = $('[data-set-group="' + groupType + '"][data-set-group-slot="off-hand"]');
    let currentValue = parseInt(offHandObj.val());
    offHandObj.val(0);
    disableChosenSelect('[data-set-group="' + groupType + '"][data-set-group-slot="off-hand"]', true);
    removeSetFromActiveList(currentValue);
  }
  else {

    let setSelected = $('[data-set-group="' + groupType + '"][data-set-group-slot="off-hand"][data-set-type="set"]').val();

    // Deselect only set select when no set is selected
    if(setSelected < 1) {
      disableChosenSelect('[data-set-group="' + groupType + '"][data-set-group-slot="off-hand"][data-set-type="set"]', false);
    }
    else {
      disableChosenSelect('[data-set-group="' + groupType + '"][data-set-group-slot="off-hand"]', false);
    }
  }

  requestBuildHash();
}

/**
 * Handles the shield trait change for the off hand selected event.
 */
function onSetWeaponTypeOffHandSelected(handle, data, overrideObject) {

  let obj
  if(overrideObject !== null && typeof overrideObject === 'object') {
    obj = overrideObject;
  }
  else {
    obj = $(handle);
  }

  let setGroup = obj.data('set-group');

  let traitSelect = $('[data-set-group="' + setGroup + '"][data-set-group-slot="off-hand"][data-set-type="trait"]');
  let traitWeaponOptions = traitSelect.find('option[data-trait-type="weapon"]');
  let traitArmorOptions = traitSelect.find('option[data-trait-type="armor"]');

  let enchantmentSelect = $('[data-set-group="' + setGroup + '"][data-set-group-slot="off-hand"][data-set-type="enchantment"]');
  let enchantmentWeaponOptions = enchantmentSelect.find('option[data-enchantment-type="weapon"]');
  let enchantmentArmorOptions = enchantmentSelect.find('option[data-enchantment-type="armor"]');

  traitSelect.val(0);
  enchantmentSelect.val(0);

  // If shield selected
  if(obj.val() === '14') {
    traitWeaponOptions.addClass('hidden');
    traitArmorOptions.removeClass('hidden');
    enchantmentWeaponOptions.addClass('hidden');
    enchantmentArmorOptions.removeClass('hidden');
  }
  else {
    traitArmorOptions.addClass('hidden');
    traitWeaponOptions.removeClass('hidden');
    enchantmentArmorOptions.addClass('hidden');
    enchantmentWeaponOptions.removeClass('hidden');
  }

  traitSelect.trigger('chosen:updated');
  enchantmentSelect.trigger('chosen:updated');

  requestBuildHash();
}

/**
 * Adds the given set to the list of active sets.
 *
 * @param {int} setId The Id of the set.
 */
function addSetToActiveList(setId) {

  if(setId > 0) {
    let element = activeSets.find(element => element.setId === setId);
    if(typeof element !== 'undefined') {
      element.amount = element.amount + 1;
    }
    else {
      activeSets.push({ setId: setId, amount: 1 });
    }
  }
}

/**
 * Removes the given set from the list of active sets.
 *
 * @param {int} setId The Id of the set.
 */
function removeSetFromActiveList(setId) {

  if(setId > 0) {

    let key = Object.keys(activeSets).find(key => activeSets[key].setId === setId);
    if(typeof key !== 'undefined') {

      key = parseInt(key);

      if(activeSets[key].amount > 1) {
        activeSets[key].amount = activeSets[key].amount - 1;
      }
      else {
        activeSets.splice(key, 1);
      }
    }
  }
}

/**
 * Build the active sets HTMl list.
 */
function setBuildActiveList() {

  if(typeof skillPlanerMode !== 'undefined' && skillPlanerMode === INPUT_MODE_READONLY) {
    return;
  }

  activeSetsListObj.children().remove();

  if(Object.keys(activeSets).length > 0) {

    let amount;
    let setNameOption;
    let setName;
    let setObj;

    // Sort by amount DESC
    let sortObjects = Object.entries(activeSets).sort(function order(a, b) {
      if (a[1].amount < b[1].amount) return +1;
      else if (a[1].amount > b[1].amount) return -1;
      else return 0;
    });

    for(let key in sortObjects) {

      setObj = sortObjects[key][1];
      amount = parseInt(activeSets[key]);
      setNameOption = setSelect.find('option[value="' + setObj.setId + '"]').first();
      setName = setNameOption.text();

      activeSetsListObj.append('<li><span><span class="amount">' + setObj.amount + 'x</span> ' + setName + '</span></li>');
    }
  }
  else {
    activeSetsListObj.append('<li class="center"><span><i class="fa fa-info-circle"></i> ' + activeSetsListObj.data('lang-no-sets') + '</span></li>');
  }
}

/**
 * Displays the champion discipline overview.
 */
function showChampionOverview() {

  panelChampionSystemFull.hide();
  panelChampionSystemPreview.show();

  // Remove current stars and descriptions
  removeChampionTree();
}

/**
 * Activates the champion discipline.
 *
 * @param {number|null} disciplineId The champion discipline Id.
 */
function activateChampionTab(disciplineId) {
  showChampionOverview();
  tabChampionSystem.removeClass('active').addClass('active');
  tabSkills.removeClass('active');
  tabSets.removeClass('active');
  panelSkills.hide();
  panelSets.hide();
  panelChampionSystem.show();
  loadChampionPreviews();
  requestBuildHash();

  if(disciplineId !== null && typeof disciplineId !== 'undefined') {
    initChampionTree(disciplineId);
  }
}

/**
 * Gets and displays a short URL.
 */
function createShortLink() {

  createShortLinkObj.html('<i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;' + langArr['build_planer.reciving_share_link']);

  if(shortLinkXHR !== null) {
    shortLinkXHR.abort();
  }

  shortLinkXHR = $.ajax({
    type: 'POST',
    url: '/ajax/create_short_link.php',
    data: { lang: lang, hash: window.location.hash }
  });

  shortLinkXHR.done(function(msg) {
    if(msg !== '') {
      prompt(langArr['build_planer.share_link_ok'], msg);
    }
    else {
      alert(langArr['build_planer.hash_invalid']);
    }
  });

  shortLinkXHR.always(function() {
    shortLinkXHR = null;
    createShortLinkObj.html('<i class="fa fa-link"></i> ' + langArr['build_planer.create_short_link']);
  });
}

/**
 * Gets the tooltip from cache or the database.
 *
 * @param {int} id The ID of the skill.
 * @param {int} points The number of skill points.
 * @param {number} type The skill type of the tooltip.
 * @param {boolean} fastLoad If true, no loading indicator is shown.
 */
function getTooltip(id, points, type, fastLoad) {

  // If a skill object available
  // Empty actionbar slots are returning undefined
  if(id !== undefined) {

    if(typeof fastLoad === 'undefined') {
      fastLoad = false;
    }

    let cpSkillPoints = {};

    // For cluster tooltips
    if(type === CHAMP_TOOLTIP_TYPE_CHAMPION_CLUSTER) {
      points = 1;

      let skillIDs = $('[data-cluster][data-id="' + id + '"]').data('cluster-skill-ids');
      let skillIDList = skillIDs.split(',');

      for(let k in skillIDList) {
        let skillID = parseInt(skillIDList[k]);
        if (champSkills.hasOwnProperty(skillID) === true) {
          cpSkillPoints[skillID] = champSkills[skillID];
        }
      }
    }

    // Default skill points
    if(type === CHAMP_TOOLTIP_TYPE_SKILL && points === 0) {
      points = 1;
    }

    // Get from cache
    if(type !== CHAMP_TOOLTIP_TYPE_CHAMPION_CLUSTER && typeof tooltipCache[type + '-' + id + '-' + points] !== 'undefined') {
      tooltip.html(tooltipCache[type + '-' + id + '-' + points]);
    }

    else {

      if(fastLoad === false) {
        tooltip.html('<i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;' + langArr['global.loading_data']);
      }

      if(tooltipXHR !== null) {
        tooltipXHR.abort();
      }

      tooltipXHR = $.ajax({
        type: 'POST',
        url: '/ajax/skill_tooltip.php',
        data: { lang: lang, id: id, points: points, type: type, skill_points: cpSkillPoints }
      });

      tooltipXHR.done(function(msg) {
        if(msg !== '') {
          tooltipCache[type + '-' + id + '-' + points] = msg;
          tooltip.html(tooltipCache[type + '-' + id + '-' + points]);
        }
      });

      tooltipXHR.always(function() {
        tooltipXHR = null;
      });
    }

    tooltip.show();
  }
}

/**
 * Beendet den Speedup Timeout und setzt die Werte zurück.
 */
function stopChampSpeedup() {

  clearTimeout(champTriggerSpeedup);
  clearTimeout(champSpeedup);

  champTriggerSpeedup = null;
  champSpeedup = null;
}

/**
 * Beendet den Speedup Timeout und setzt die Werte zurück.
 */
function stopAttributeSpeedup() {

  clearTimeout(attributeTriggerSpeedup);
  clearTimeout(attributeSpeedup);

  attributeTriggerSpeedup = null;
  attributeSpeedup = null;
}

/**
 * Initialisiert die Attributpunkte.
 */
function setAttrPoints() {

  if(attrMagicka === 0) {
    $('#attrMagickaMinus').css('opacity', OPACITY_INACTIVE);
  }
  else {
    $('#attrMagickaMinus').css('opacity', OPACITY_ACTIVE);
  }

  if(attrHealth === 0) {
    $('#attrHealthMinus').css('opacity', OPACITY_INACTIVE);
  }
  else {
    $('#attrHealthMinus').css('opacity', OPACITY_ACTIVE);
  }

  if(attrStamina === 0) {
    $('#attrStaminaMinus').css('opacity', OPACITY_INACTIVE);
  }
  else {
    $('#attrStaminaMinus').css('opacity', OPACITY_ACTIVE);
  }

  // Plus de- und aktivieren
  if((attrMagicka + attrHealth + attrStamina) >= ATTRIBUTES_MAX_POINTS) {
    $('#attrMagickaPlus').css('opacity', OPACITY_INACTIVE);
    $('#attrHealthPlus').css('opacity', OPACITY_INACTIVE);
    $('#attrStaminaPlus').css('opacity', OPACITY_INACTIVE);
  }
  else {
    $('#attrMagickaPlus').css('opacity', OPACITY_ACTIVE);
    $('#attrHealthPlus').css('opacity', OPACITY_ACTIVE);
    $('#attrStaminaPlus').css('opacity', OPACITY_ACTIVE);
  }

  // Attributspunkte anzeigen
  $('#attrMagicka').html(attrMagicka);
  $('#attrHealth').html(attrHealth);
  $('#attrStamina').html(attrStamina);
}

/**
 * Requests the build hash action.
 */
function requestBuildHash() {

  if(buildHashTimeout !== null) {
    window.clearTimeout(buildHashTimeout);
  }

  buildHashTimeout = setTimeout(function() {
    buildHash();
  }, HASH_BUILD_INTERVAL);
}

/**
 * Creates the hash from the selected planer values.
 */
function buildHash() {

  // Query stucture
  // 1 = Base infos
  //    1 = Version
  //    2 = Alliance
  //    3 = Race
  //    4 = Class
  //    5 = Mundus
  //    6 = Magicka
  //    7 = Health
  //    8 = Stamina
  // 2 = Skills
  // 3 = Actionbars
  // 4 = Sets
  // 5 = CP Counts (Red, Blue and Green)
  // 6 = CP
  // 7 = CP Active Slots

  let query = '';
  let champTotalPoints = getChampionTotalPoints();

  // Build the final query
  query += getQueryBase() + SEPERATOR_BLOCK; // 1
  query += getQuerySkills() + SEPERATOR_BLOCK; // 2
  query += getQueryActionBar() + SEPERATOR_BLOCK; // 3
  query += getQuerySets() + SEPERATOR_BLOCK; // 4
  query += champTotalPoints.green + ',' + champTotalPoints.blue + ',' + champTotalPoints.red + SEPERATOR_BLOCK; // 5
  query += getQueryChampionSkills() + SEPERATOR_BLOCK; // 6
  query += getQueryActiveChampionSkills() + SEPERATOR_BLOCK; // 7

  // Mode: Hash
  if(inputMode === INPUT_MODE_HASH) {

    window.location.href = '#' + query;

    // Set language change URL
    setLangUrls();

    shareLink.val(window.location.href);

    // Semicolon is now threated as query separator and will be transformed to &
    // Encode the query value to base64
    saveBtn.addData('url', saveBtnBaseUri + encodeURI(btoa(query)));

    shareBox.show();
  }

  // Mode: Input
  else if(inputMode === INPUT_MODE_INPUT) {
    inputModeObj.val(query);
    $('#skillPlanerPoints').val(totalPoints.toString());
  }

  skillTotalPoints.html(totalPoints.toString());

  if(inputGlobalHashObj.length > 0) {
    inputGlobalHashObj.val('#' + query);
  }
}

/**
 * Gets the base info for the query string.
 *
 * @returns {string}
 */
function getQueryBase() {

  // 1 = Version
  // 2 = Alliance
  // 3 = Race
  // 4 = Class
  // 5 = Mundus
  // 6 = Magicka
  // 7 = Leben
  // 8 = Ausdauer
  let baseQuery = 'v2' + SEPERATOR_DATA; // 1-1
  baseQuery += skillFaction + SEPERATOR_DATA; // 1-2
  baseQuery += skillRace + SEPERATOR_DATA; // 1-3
  baseQuery += skillClass + SEPERATOR_DATA; // 1-4
  baseQuery += skillMundus + SEPERATOR_DATA; // 1-5
  baseQuery += attrMagicka + SEPERATOR_DATA; // 1-6
  baseQuery += attrHealth + SEPERATOR_DATA; // 1-7
  baseQuery += attrStamina; // 1-8

  return baseQuery;
}

/**
 * Gets the skills for the query string.
 *
 * @returns {string}
 */
function getQuerySkills() {

  let skillsQuery = '';

  if(Object.keys(querySkills).length > 0) {
    for(let key in querySkills) {
      skillsQuery += key + SEPERATOR_PAIR + querySkills[key] + SEPERATOR_DATA;
    }

    // Remove last seperator
    if(skillsQuery !== '') {
      skillsQuery = skillsQuery.substring(0, skillsQuery.length - 1);
    }
  }

  return skillsQuery;
}

/**
 * Gets the actionbar for the query string.
 *
 * @returns {string}
 */
function getQueryActionBar() {

  let actionBars = '';
  let slotID;

  for(let i = 1; i <= 2; i++) {

    // Hotkey Seperator
    if(i > 1) {
      actionBars = actionBars + SEPERATOR_DATA;
    }

    for(let x = 1; x <= 6; x++) {

      // Actionbar seperator
      if(x > 1) {
        actionBars = actionBars + SEPERATOR_PAIR;
      }

      slotID = $('#bar' + i + '_' + ((x === 6) ? 'r' : x)).children('img.slot').data('id');
      actionBars = actionBars + ((slotID > 0) ? slotID : 0);
    }
  }

  return actionBars;
}

/**
 * Gets the sets for the query string.
 *
 * @returns {string}
 */
function getQuerySets() {

  let query = '';

  for(let i = 0; i < SET_TYPES.length; i++) {

    let setType = SET_TYPES[i].type;
    let setTypeQueryIndex = SET_TYPES[i].query_index;
    let elementSelector = '[data-set-group="' + setType + '"]';

    if(SET_TYPES[i].hasOwnProperty('group_slot') === true) {
      elementSelector += '[data-set-group-slot="' + SET_TYPES[i].group_slot + '"]';
    }

    let setValue = $(elementSelector + '[data-set-type="set"]').val();
    if(setValue > 0) {

      let typeValue = '';
      let armorTypeValue = $(elementSelector + '[data-set-type="armor-type"]').val();
      let weaponTypeValue = $(elementSelector + '[data-set-type="weapon-type"]').val();
      let qualityValue = $(elementSelector + '[data-set-type="quality"]').val();
      let traitValue = $(elementSelector + '[data-set-type="trait"]').val();
      let enchantmentValue = $(elementSelector + '[data-set-type="enchantment"]').val();
      let isPoison = ($(elementSelector + '[data-set-poison="1"]').length > 0);

      if(typeof armorTypeValue !== 'undefined') {
        typeValue = armorTypeValue;
      }
      if(typeof weaponTypeValue !== 'undefined') {
        typeValue = weaponTypeValue;
      }

      if(isPoison === true) {
        query += setTypeQueryIndex + SEPERATOR_PAIR + setValue + SEPERATOR_DATA;
      }
      else {
        query += setTypeQueryIndex + SEPERATOR_PAIR + setValue + SEPERATOR_PAIR + typeValue + SEPERATOR_PAIR + qualityValue + SEPERATOR_PAIR + traitValue + SEPERATOR_PAIR + enchantmentValue + SEPERATOR_DATA;
      }
    }
  }

  if(query !== '') {
    query = query.substring(0, query.length - 1);
  }

  return query;
}

/**
 * Gets the champion skills for the query string.
 *
 * @returns {string}
 */
function getQueryChampionSkills() {

  let query = '';

  if(Object.keys(champSkills).length > 0) {
    for(let key in champSkills) {
      query += key + SEPERATOR_PAIR + champSkills[key] + SEPERATOR_DATA;
    }

    // Remove last seperator
    if(query !== '') {
      query = query.substring(0, query.length - 1);
    }
  }

  return query;
}

/**
 * Gets the active champion skills for the query string.
 *
 * @returns {string}
 */
function getQueryActiveChampionSkills() {

  let query = '';

  if(Object.keys(champActiveSkills).length > 0) {
    for(let slotIndex in champActiveSkills) {
      query += slotIndex + SEPERATOR_PAIR + champActiveSkills[slotIndex] + SEPERATOR_DATA;
    }

    // Remove last seperator
    if(query !== '') {
      query = query.substring(0, query.length - 1);
    }
  }

  return query;
}

/**
 * parseHash - Parst den übergebene Hash-Wert und setzt den Skillplaner
 * entsprechend der Werte.
 *
 * @param	{string} hash Der Hash-Wert der geparst werden soll.
 */
function parseHash(hash) {

  // Remove the hashtag on string start
  if(hash.substring(0, 1) === '#') {
    hash = hash.substring(1, hash.length);
  }

  let hashVersion = getHashVersion(hash);
  if(hashVersion === HASH_VERSION) {
    parseHashV2(hash);
  }
  else if(hashVersion === 1) {
    migrateHashV1(hash);
  }
}

/**
 * Gets the hash version.
 *
 * @param hash The hash data.
 * @returns {number|null} Returns the hash version or null if the hash has no
 *   version.
 */
function getHashVersion(hash) {

  let version;

  if(hash.substring(0, 1) === 'v') {
    let data = hash.substring(1, 4).split(SEPERATOR_DATA);
    version = parseInt(data[0]);
  }
  else if(hash.substring(0, 1) === 'f') {
    version = 1;
  }

  return version;
}

/**
 * Migrates the hash version 1 data to version 2.
 *
 * @param {string} hash The hash version 1 data.
 */
function migrateHashV1(hash) {

  let syntaxCheckArray = hash.substring(0, 12).split(SEPERATOR_DATA);
  let offsetStart = null;
  let offsetEnd = hash.indexOf(SEPERATOR_BLOCK);
  let hashFaction = 0;
  let hashRace = 0;
  let hashClass = 0;
  let hashSkills = '';
  let hashMundus = 0;
  let hashAttrMagicka = 0;
  let hashAttrHealth = 0;
  let hashAttrStamina = 0;
  let hashActionBar1;
  let hashActionBar2;
  let hashActionBars;

  if(syntaxCheckArray.length >= 3) {
    if(syntaxCheckArray[0].substring(0, 1) === 'f' && syntaxCheckArray[1].substring(0, 1) === 'r' && syntaxCheckArray[2].substring(0, 1) === 'c') {
      if(isNumber(syntaxCheckArray[0].substring(1, 1)) === true && isNumber(syntaxCheckArray[1].substring(1, 1)) === true && isNumber(syntaxCheckArray[2].substring(1, 1)) === true) {

        // Fix if no skill is selected
        let classLength = syntaxCheckArray[2].length;
        if(syntaxCheckArray[2].indexOf(SEPERATOR_BLOCK) !== -1) {
          classLength = syntaxCheckArray[2].indexOf(SEPERATOR_BLOCK) - 1;
        }

        hashFaction = syntaxCheckArray[0].substring(1, syntaxCheckArray[0].length);
        hashRace = syntaxCheckArray[1].substring(1, syntaxCheckArray[1].length);
        hashClass = syntaxCheckArray[2].substring(1, classLength);
        offsetStart = syntaxCheckArray[0].length + syntaxCheckArray[1].length + syntaxCheckArray[2].length + 3;
      }
    }
  }

  if(offsetStart !== null) {

    // Fallback for old builds
    if(offsetEnd === -1) {
      offsetEnd = 999999;
    }

    let skillPoints = hash.substring(offsetStart, offsetEnd - offsetStart);
    if(skillPoints !== '') {
      hashSkills = skillPoints;
    }
  }

  // Extradaten parsen
  // 1 = Aktionsleisten
  // 2 = Mundusstein
  // 3 = Magicka, Leben, Ausdauer
  // 4 = Rüstugnsteile: Leicht, Mittel, Schwer
  // 5 = Championpunkte
  // 6 = Championpunkte Anzahl (Thief,Mage,Warrior)
  // 7 = Waffentypen
  // 8 = Sets
  let extraDataArr = hash.substring(offsetEnd + 1).split(';');

  // Actionbar 1
  if(typeof extraDataArr[0] !== 'undefined') {
    let actionBarSlots = extraDataArr[0].split(':');
    if(actionBarSlots.length === HASH_NUM_ACTIONBAR_SLOTS) {
      hashActionBar1 = extraDataArr[0];
    }
  }
  else {
    hashActionBar1 = '0' + SEPERATOR_PAIR + '0' + SEPERATOR_PAIR + '0' + SEPERATOR_PAIR + '0' + SEPERATOR_PAIR + '0' + SEPERATOR_PAIR + '0';
  }

  // Actionbar 2
  if(typeof extraDataArr[1] !== 'undefined') {
    let actionBarSlots = extraDataArr[1].split(':');
    if(actionBarSlots.length === HASH_NUM_ACTIONBAR_SLOTS) {
      hashActionBar2 = extraDataArr[1];
    }
  }
  else {
    hashActionBar2 = '0' + SEPERATOR_PAIR + '0' + SEPERATOR_PAIR + '0' + SEPERATOR_PAIR + '0' + SEPERATOR_PAIR + '0' + SEPERATOR_PAIR + '0';
  }

  hashActionBars = hashActionBar1 + SEPERATOR_DATA + hashActionBar2;

  if(typeof extraDataArr[2] !== 'undefined') {
    hashMundus = parseInt(extraDataArr[2]);
  }

  if(typeof extraDataArr[3] !== 'undefined') {

    let attributeArr = extraDataArr[3].split(',');
    if(attributeArr.length === 3) {
      if(isNumber(attributeArr[0]) === true && isNumber(attributeArr[1]) === true && isNumber(attributeArr[2]) === true) {
        hashAttrMagicka = parseInt(attributeArr[0]);
        hashAttrHealth = parseInt(attributeArr[1]);
        hashAttrStamina = parseInt(attributeArr[2]);
      }
    }
  }

  let hashVersion2 = '#v2' + SEPERATOR_DATA;
  hashVersion2 += hashFaction + SEPERATOR_DATA;
  hashVersion2 += hashRace + SEPERATOR_DATA;
  hashVersion2 += hashClass + SEPERATOR_DATA;
  hashVersion2 += hashMundus + SEPERATOR_DATA;
  hashVersion2 += hashAttrMagicka + SEPERATOR_DATA;
  hashVersion2 += hashAttrHealth + SEPERATOR_DATA;
  hashVersion2 += hashAttrStamina + SEPERATOR_BLOCK;
  hashVersion2 += hashSkills + SEPERATOR_BLOCK;
  hashVersion2 += hashActionBars + SEPERATOR_BLOCK;
  hashVersion2 += SEPERATOR_BLOCK; // Sets
  hashVersion2 += SEPERATOR_BLOCK; // CP Counts (Green, Blue and Red)
  hashVersion2 += SEPERATOR_BLOCK; // CP
  hashVersion2 += SEPERATOR_BLOCK; // CP Active Skills

  let locationBase = window.location.href.replace(window.location.hash, '')
  window.location.href = locationBase + hashVersion2;
  window.location.reload();
}

/**
 * Parses the hash version 2 data.
 *
 * @param {string} hash The hash version 2 data.
 */
function parseHashV2(hash) {

  let hashData = hash.split(SEPERATOR_BLOCK);
  if(hashData.length === HASH_NUM_BLOCKS) {

    let baseResult = parseHashBaseQuery(hashData[0]);
    if(baseResult === true) {
      parseHashSkillsQuery(hashData[1]);
      parseHashActionsBarsQuery(hashData[2]);
      parseHashSetQuery(hashData[3]);
      parseHashChampionSkillsQuery(hashData[5]);
      parseHashChampionActiveSkillsQuery(hashData[6]);

      skillTotalPoints.html(totalPoints.toString());
      shareBox.show();

      if(typeof skillPlanerMode === 'undefined' || skillPlanerMode !== INPUT_MODE_READONLY) {
        setLangUrls();
      }

      if(inputGlobalHashObj.length > 0) {
        inputGlobalHashObj.val(window.location.hash);
      }
    }
  }
}

/**
 * Parses the base query string part and set the values to the planer.
 *
 * @param {string} data The query string base data string.
 * @returns {boolean} Returns True if no error occured otherwise False.
 */
function parseHashBaseQuery(data) {

  let status = false;
  let dataArr = data.split(SEPERATOR_DATA);

  // Check entry count and version
  if(dataArr.length === HASH_BASE_INFO_NUM_ENTRIES) {

    attrMagicka = parseInt(dataArr[5]);
    attrHealth = parseInt(dataArr[6]);
    attrStamina = parseInt(dataArr[7]);

    setFaction(dataArr[1]);
    setRace(dataArr[2]);
    setClass(dataArr[3]);
    setMundus(dataArr[4]);
    setAttrPoints();

    status = true;
  }

  return status;
}

/**
 * Parses the skills query string part and set the values to the planer.
 *
 * @param {string} data The query string skills data string.
 * @returns {boolean} Returns True if no error occured otherwise False.
 */
function parseHashSkillsQuery(data) {

  let status = false;
  let dataArr = data.split(SEPERATOR_DATA);

  if(dataArr.length > 0) {

    let pairData;
    let skillObj;
    let skillId;
    let skillNumPoints;

    for(let k in dataArr) {
      if(dataArr[k].indexOf(SEPERATOR_PAIR) !== -1) {
        pairData = dataArr[k].split(SEPERATOR_PAIR);
        if(isNumber(pairData[0]) === true && isNumber(pairData[1]) === true) {

          skillId = parseInt(pairData[0]);
          skillNumPoints = parseInt(pairData[1]);
          skillObj = $('img.skill_icon[data-id="' + skillId + '"]');
          activeateSkill(skillId, skillNumPoints, true);

          // Activate parent skill
          if(skillObj.data('parent') > 0) {
            if($('img.skill_icon[data-id="' + skillObj.data('parent') + '"]').data('points-enabled') === 1) {
              activeateSkill(skillObj.data('parent'), 1, false);
            }

            delete querySkills[skillObj.data('parent')];

            if(skillObj.data('skill-type') === 'active') {
              delete skillsActive[skillObj.data('parent')];
            }
            else if(skillObj.data('skill-type') === 'ultimate') {
              delete skillsUltimate[skillObj.data('parent')];
            }
          }
        }
      }
    }

    status = true;
  }

  return status;
}

/**
 * Parses the actionsbars query string part and set the values to the planer.
 *
 * @param {string} data The query string actionsbars data string.
 * @returns {boolean} Returns True if no error occured otherwise False.
 */
function parseHashActionsBarsQuery(data) {

  let status = false;
  let dataArr = data.split(SEPERATOR_DATA);

  if(dataArr.length >= HASH_MIN_NUM_ACTIONBARS) {

    let slot;
    let slots;
    let slotSkillId;
    let skillItem;
    let barCount;
    let barSlotObj;

    for(let k in dataArr) {
      if(dataArr[k].indexOf(SEPERATOR_PAIR) !== -1) {

        barCount = parseInt(k) + 1;
        slots = dataArr[k].split(SEPERATOR_PAIR);

        if(slots.length === HASH_NUM_ACTIONBAR_SLOTS) {
          for(let i = 0; i < HASH_NUM_ACTIONBAR_SLOTS; i++) {

            slotSkillId = parseInt(slots[i]);

            // Skip empty slots
            if(slotSkillId === 0) {
              continue;
            }

            skillItem = $('img.skill_icon[data-id="' + slotSkillId + '"], img.skill_icon_static[data-id="' + slotSkillId + '"]');
            if(skillItem.length > 0) {
              slot = (i + 1)
            }

            // Ultimate slot
            if (slot === 6) {
              slot = 'r';
            }

            barSlotObj = $('#bar' + barCount + '_' + slot);
            barSlotObj.children('img.skill').attr('src', skillItem.data('icon'));
            barSlotObj.children('img.slot').addData('id', slotSkillId).addData('points', skillItem.data('points'));
          }
        }
      }
    }

    status = true;
  }

  return status;
}

/**
 * Parses the sets query string part and set the values to the planer.
 *
 * @param {string} data The query string sets data string.
 * @returns {boolean} Returns True if no error occured otherwise False.
 */
function parseHashSetQuery(data) {

  let status = false;
  let dataArr = data.split(SEPERATOR_DATA);

  if(dataArr.length > 0) {

    let selectObj;
    let setInfo;
    let elementSelector;
    let setSlot;
    let setId;
    let setType;
    let setTypeIndex;
    let setQuality;
    let setTrait;
    let setEnchantment;
    let setWeaponType;
    let setWeaponGroupSlot;
    let hasMythic = false;

    for(let k in dataArr) {
      if(dataArr[k].indexOf(SEPERATOR_PAIR) !== -1) {

        // 0 = Slot
        // 1 = Set Id
        // 2 = Armor type / Weapon type
        // 3 = Quality
        // 4 = Trait
        // 5 = Enchantment
        setInfo = dataArr[k].split(SEPERATOR_PAIR);
        if(setInfo.length >= HASH_NUM_SET_MIN_FIELDS) {

          setSlot = parseInt(setInfo[0]);
          setId = parseInt(setInfo[1]);
          setType = 0;
          setQuality = 0;
          setTrait = 0;
          setEnchantment = 0;

          for(let x = 0; x < SET_TYPES.length; x++) {
            if(SET_TYPES[x].query_index === setSlot) {

              if(typeof SET_TYPES[x].group_slot !== 'undefined') {
                setWeaponType = SET_TYPES[x].type;
                setWeaponGroupSlot = SET_TYPES[x].group_slot;
                setTypeIndex = 'weapon-type';
                elementSelector = '[data-set-group="' + SET_TYPES[x].type + '"][data-set-group-slot="' + SET_TYPES[x].group_slot + '"]';
              }
              else {
                setTypeIndex = 'armor-type';
                elementSelector = '[data-set-group="' + SET_TYPES[x].type + '"]';
              }

              break;
            }
          }

          // Mythic and other handling for normal sets
          // This is not required for poison slots
          if(isPoisonSlot(setSlot) === false) {

            setType = parseInt(setInfo[2]);
            setQuality = parseInt(setInfo[3]);
            setTrait = parseInt(setInfo[4]);
            setEnchantment = parseInt(setInfo[5]);

            // Keep only the first mythic item, set other mythics blank
            // This prevents URL manipulation
            let setSelectObj = setSelect.find('option[value="' + setId + '"][data-mythic="1"]');
            if(setSelectObj.data('mythic') === 1) {
              if(hasMythic === true) {
                continue;
              }
              else {
                hasMythic = true;
              }
            }
          }

          if(setId > 0) {
            selectObj = $(elementSelector + '[data-set-type="set"]');
            selectObj.val(setId).addData('current-value', setId).trigger('chosen:updated');
            onSetSelected(null, null, selectObj);
          }
          if(setType > 0 && setTypeIndex !== '') {
            $(elementSelector + '[data-set-type="' + setTypeIndex + '"]').val(setType).trigger('chosen:updated');

            // Trigger selected event for manual change for main hand weapon type select
            if(setTypeIndex === 'weapon-type' && setWeaponGroupSlot === 'main-hand') {
              onSetWeaponTypeSelected(null, null, $('[data-set-group="' + setWeaponType + '"][data-set-group-slot="main-hand"][data-set-type="weapon-type"]'));
            }
            // Trigger selected event for manual change for main hand weapon type select
            if(setTypeIndex === 'weapon-type' && setWeaponGroupSlot === 'off-hand') {
              onSetWeaponTypeOffHandSelected(null, null, $('[data-set-group="' + setWeaponType + '"][data-set-group-slot="off-hand"][data-set-type="weapon-type"]'));
            }
          }
          if(setQuality > 0) {
            $(elementSelector + '[data-set-type="quality"]').val(setQuality).trigger('chosen:updated');
          }
          if(setTrait > 0) {
            $(elementSelector + '[data-set-type="trait"]').val(setTrait).trigger('chosen:updated');
          }
          if(setEnchantment > 0) {
            $(elementSelector + '[data-set-type="enchantment"]').val(setEnchantment).trigger('chosen:updated');
          }
        }
      }
    }
  }

  return status;
}

/**
 * Parses the champion skills query string part and set the values to the planer.
 *
 * @param {string} data The query string champion skills data string.
 * @returns {boolean}
 */
function parseHashChampionSkillsQuery(data) {

  let status = false;
  let dataArr = data.split(SEPERATOR_DATA);

  if(dataArr.length > 0) {

    let pairData;
    let skillId;
    let skillPoints;
    let hashTotalPoints = 0;

    for(let k in dataArr) {
      if(dataArr[k].indexOf(SEPERATOR_PAIR) !== -1) {
        pairData = dataArr[k].split(SEPERATOR_PAIR);
        if(isNumber(pairData[0]) === true && isNumber(pairData[1]) === true) {

          skillId = parseInt(pairData[0]);
          skillPoints = parseInt(pairData[1]);

          hashTotalPoints += skillPoints;

          champSkills[skillId] = skillPoints;
          setDisciplinePoints(skillId, skillPoints);

          // Reduce the points to not exceed the maximum points
          if(hashTotalPoints > cpMaxPoints) {

            let toMuchPoints = hashTotalPoints - cpMaxPoints;
            if(toMuchPoints > 0) {
              champSkills[skillId] -= toMuchPoints;
              setDisciplinePoints(skillId, -toMuchPoints);
            }

            break;
          }
        }
      }
    }

    status = true;
  }

  setChampionSpentPoints();

  return status;
}

/**
 * Parses the active champion skills query string part and set the values to the planer.
 *
 * @param {string} data The query string active champion skills data string.
 * @returns {boolean}
 */
function parseHashChampionActiveSkillsQuery(data) {

  let status = false;
  let dataArr = data.split(SEPERATOR_DATA);

  if(dataArr.length > 0) {

    let pairData;
    let slotIndex;
    let skillId;

    for(let k in dataArr) {
      if(dataArr[k].indexOf(SEPERATOR_PAIR) !== -1) {
        pairData = dataArr[k].split(SEPERATOR_PAIR);
        if(isNumber(pairData[0]) === true && isNumber(pairData[1]) === true) {

          slotIndex = parseInt(pairData[0]);
          skillId = parseInt(pairData[1]);

          if(slotIndex >= CHAMP_BAR_SLOT_INDEX_MIN && slotIndex <= CHAMP_BAR_SLOT_INDEX_MAX) {
            if(champSkills.hasOwnProperty(skillId) === true) {

              let draggable = 'true';
              if(inputMode === INPUT_MODE_READONLY) {
                draggable = 'false';
              }

              $('[data-bar="' + slotIndex + '"]').addData('skill-id', skillId).html(CHAMP_BAR_SLOT_HTML.replace('draggable="true"', 'draggable="' + draggable + '"'));
              champActiveSkills[slotIndex] = skillId;
            }
          }
        }
      }
    }
  }

  return status;
}

/**
 * Sets the discipline skill points.
 *
 * @param {number} id The champion skill ID.
 * @param {number} points The spent champion points for this skill ID.
 */
function setDisciplinePoints(id, points) {

  let disciplineId;

  // Set discpline points to global store
  if(cpSkillDisciplineMapping.hasOwnProperty(id) === true) {

    disciplineId = cpSkillDisciplineMapping[id];

    if(typeof champPointsPerDiscipline[disciplineId] === 'undefined') {
      champPointsPerDiscipline[disciplineId] = 0;
    }

    champPointsPerDiscipline[disciplineId] += points;
  }

  if(typeof disciplineId !== 'undefined' && cpDisciplineClusterMapping.hasOwnProperty(disciplineId) === true) {

    let clusterDisciplineId = cpDisciplineClusterMapping[disciplineId];

    if(typeof champPointsPerDiscipline[clusterDisciplineId] === 'undefined') {
      champPointsPerDiscipline[clusterDisciplineId] = 0;
    }

    champPointsPerDiscipline[clusterDisciplineId] += points;
  }
}

/**
 * Appends the hash to the language change URLs.
 */
function setLangUrls() {
  $('a.lang_url').each(function(key, value) {
    $(value).attr('href', $(value).data('base-url') + window.location.hash);
  });
}

/**
 * Sets the given faction active.
 *
 * @param {string} factionID The faction Id.
 */
function setFaction(factionID) {

  if(inputMode !== INPUT_MODE_READONLY) {

    factionSelectObj.css('opacity', OPACITY_INACTIVE);
    skillFaction = parseInt(factionID);

    if(factionID > 0) {
      let factionObj = $('img[data-faction="' + factionID + '"]');
      factionObj.css('opacity', OPACITY_ACTIVE);
      $('li[data-faction="' + factionID + '"]').css('opacity', OPACITY_ACTIVE);
      factionDropDown.attr('src', factionObj.attr('src'));
      factionDropDownContent.hide();
    }
  }
}

/**
 * Sets the given race active.
 *
 * @param {string} raceID The race Id.
 */
function setRace(raceID) {

  // Only reset if selection has changed
  if(skillRace !== 0 && raceID !== skillRace) {
    resetRace();
  }

  skillRace = parseInt(raceID);

  let tree1Obj = $('li.tree_race_1');

  tree1Obj.parent().children('li.infotext').hide();
  $('li.tree_race').hide();
  $('li.tree_race_' + skillRace).show();
  $('span.category_header[data-id="44"]').html(inGameRaces[skillRace]);

  if(skillRace === 0) {
    tree1Obj.parent().children('li.infotext').show();
  }

  if(inputMode !== INPUT_MODE_READONLY) {
    raceSelectObj.css('opacity', OPACITY_INACTIVE);
  }

  // Aktiv setzen
  if(raceID > 0) {
    let raceImgObj = $('img[data-race="' + raceID + '"]');
    raceImgObj.css('opacity', OPACITY_ACTIVE);
    $('li[data-race="' + raceID + '"]').css('opacity', OPACITY_ACTIVE);
    raceDropDown.attr('src', raceImgObj.attr('src'));
    raceDropDownContent.hide();
  }

  passiveSkillList.find('li > img[data-race-skill="1"]').each(function(key, value) {
    removePassiveList($(value));
  });
}

/**
 * Sets the given class active.
 *
 * @param {string} classID The class Id.
 */
function setClass(classID) {

  // Only reset if selection has changed
  if(skillClass !== 0 && classID !== skillClass) {
    resetClass();
  }

  skillClass = parseInt(classID);

  let tree1Obj = $('li.tree_class_1');

  tree1Obj.parent().children('li.infotext').hide();
  $('li.tree_class').hide();
  $('li.tree_class_' + skillClass).show();
  $('span.category_header[data-id="1"]').html(inGameClasses[skillClass]);

  if(skillClass === 0) {
    tree1Obj.parent().children('li.infotext').show();
  }

  if(inputMode !== INPUT_MODE_READONLY) {
    classSelectObj.css('opacity', OPACITY_INACTIVE);
  }

  if(classID > 0) {
    let classImgObj = $('img[data-class="' + classID + '"]');
    classImgObj.css('opacity', OPACITY_ACTIVE);
    $('li[data-class="' + classID + '"]').css('opacity', OPACITY_ACTIVE);
    classDropDown.attr('src', classImgObj.attr('src'));
    classDropDownContent.hide();
  }

  passiveSkillList.find('li > img[data-class-skill="1"]').each(function(key, value) {
    removePassiveList($(value));
  });
}

/**
 * Sets the given mundus stone active.
 *
 * @param {string} mundusID The mundus stone Id.
 */
function setMundus(mundusID) {

  skillMundus = parseInt(mundusID);

  if(inputMode !== INPUT_MODE_READONLY) {
    mundusSelectObj.css('opacity', OPACITY_INACTIVE);
  }

  if(mundusID > 0) {
    let mundusImgObj = $('img[data-mundus="' + mundusID + '"]');
    mundusImgObj.css('opacity', OPACITY_ACTIVE);
    $('li[data-mundus="' + mundusID + '"]').css('opacity', OPACITY_ACTIVE);
    mundusDropDown.attr('src', mundusImgObj.attr('src'));
    mundusDropDownContent.hide();
  }
}

/**
 * Resets the active race.
 */
function resetRace() {

  if(inputMode !== INPUT_MODE_READONLY) {

    let obj = null;
    let skillTreeNameObj = $('#skillTreeName');

    skillTreeNameObj.html(skillTreeNameObj.data('text-default'));
    $('#skillInfoText').show();
    $('div.ultimate').hide();
    $('div.active').hide();
    $('div.passive').hide();

    // Reset skill points
    $('img.skill_icon[data-race-skill="1"]').each(function(key, val) {

      obj = $(val);

      $('#skillTreeUltimate' + obj.data('id')).hide();
      $('#skillTreeActive' + obj.data('id')).hide();
      $('#skillTreePassive' + obj.data('id')).hide();

      if(obj.data('points') > obj.data('points-min')) {

        totalPoints = totalPoints - obj.data('points');
        obj.addData('points', obj.data('points-min'));
        $('span.skill_icon_count[data-id="' + obj.data('id') + '"]').html(obj.data('points-min') + '/' + obj.data('points-max'));

        resetMorphs(obj.data('id'));

        $(this).css('opacity', OPACITY_INACTIVE);

        delete skills[obj.data('id')];
        delete querySkills[obj.data('id')];

        if(obj.data('skill-type') === 'active') {
          delete skillsActive[obj.data('id')];
        }
        else if(obj.data('skill-type') === 'ultimate') {
          delete skillsUltimate[obj.data('id')];
        }
      }
    });

    // Reset morph tree
    $('li.morph_tree[data-race-skill="1"]').attr('class', 'unselectable morph_tree morph_tree_disabled');

    raceSelectObj.css('opacity', OPACITY_INACTIVE);
    skillRace = 0;
  }
}

/**
 * Resets the active class.
 */
function resetClass() {

  if(inputMode !== INPUT_MODE_READONLY) {

    let obj = null;
    let skillTreeNameObj = $('#skillTreeName');

    skillTreeNameObj.html(skillTreeNameObj.data('text-default'));
    $('#skillInfoText').show();
    $('div.ultimate').hide();
    $('div.active').hide();
    $('div.passive').hide();

    // Reset skill points
    $('img.skill_icon[data-class-skill="1"]').each(function(key, val) {

      obj = $(val);

      $('#skillTreeUltimate' + obj.data('id')).hide();
      $('#skillTreeActive' + obj.data('id')).hide();
      $('#skillTreePassive' + obj.data('id')).hide();

      if(obj.data('points') > obj.data('points-min')) {

        totalPoints = totalPoints - obj.data('points');
        obj.addData('points', obj.data('points-min'));
        $('span.skill_icon_count[data-id="' + obj.data('id') + '"]').html('0/' + obj.data('points-max'));

        resetMorphs(obj.data('id'));

        // Reset morphs
        $('li.morph_tree[data-class-skill="1"]').attr('class', 'unselectable morph_tree morph_tree_disabled');

        $(this).css('opacity', OPACITY_INACTIVE);

        delete skills[obj.data('id')];
        delete querySkills[obj.data('id')];

        if(obj.data('skill-type') === 'active') {
          delete skillsActive[obj.data('id')];
        }
        else if(obj.data('skill-type') === 'ultimate') {
          delete skillsUltimate[obj.data('id')];
        }
      }
    });

    requestBuildHash();
  }
}

/**
 * Resets the morph an it's skills.
 *
 * @param {int} id The parent skill Id.
 */
function resetMorphs(id) {

  $('img[data-parent="' + id + '"]').each(function(key, value) {

    let morphObj = $(value);

    if(morphObj.data('points') > morphObj.data('points-min')) {

      totalPoints = totalPoints - morphObj.data('points');

      if(morphObj.data('points-min') > 0) {
        totalPoints = totalPoints - morphObj.data('points-min');
      }

      $('span.skill_icon_count[data-id="' + morphObj.data('id') + '"]').html(morphObj.data('points-min') + '/' + morphObj.data('points-max'));

      morphObj.addData('points', morphObj.data('points-min'));
      morphObj.css('opacity', OPACITY_INACTIVE);

      if(typeof skills[morphObj.data('id')] !== 'undefined') {
        delete skills[morphObj.data('id')];
      }
      if(typeof querySkills[morphObj.data('id')] !== 'undefined') {
        delete querySkills[morphObj.data('id')];

        if(morphObj.data('skill-type') === 'active') {
          delete skillsActive[morphObj.data('id')];
        }
        else if(morphObj.data('skill-type') === 'ultimate') {
          delete skillsUltimate[morphObj.data('id')];
        }
      }
    }
  });
}

/**
 * Activates the given skill with the given points.
 *
 * @param {number} id The Id of the skill.
 * @param {number} points DThe number of points to set for the skill.
 * @param {boolean} checkMorphTree If True the morph tree will be adjusted if needed.
 */
function activeateSkill(id, points, checkMorphTree) {

  if(typeof points !== 'number') {
    points = parseInt(points);
  }

  let skillObj = $('img.skill_icon[data-id="' + id + '"]');
  let skillObjCount = $('span.skill_icon_count[data-id="' + id + '"]');

  if(points > skillObj.data('points-max')) {
    points = parseInt(skillObj.data('points-max'));
  }

  skillObj.css('opacity', OPACITY_ACTIVE);
  skillObj.addData('points', points);
  skillObjCount.html(points + '/' + skillObj.data('points-max'));

  skills[id] = points;
  querySkills[id] = points;

  if(skillObj.data('skill-type') === 'active') {
    skillsActive[id] = 1;
  }
  else if(skillObj.data('skill-type') === 'ultimate') {
    skillsUltimate[id] = 1;
  }

  else if(skillObj.data('skill-type') === 'passive') {
    addPassiveList(skillObj);
  }

  if(typeof skillObj.data('points-enabled') === 'undefined' || skillObj.data('points-enabled') === 1) {

    totalPoints = totalPoints + parseInt(points);

    if(skillObj.data('points-min') > 0) {
      totalPoints = totalPoints - skillObj.data('points-min');
    }
  }

  if(checkMorphTree === true) {

    switch(skillObj.data('type')) {
      case 'parent':
        $('li.morph_tree[data-parent="' + skillObj.data('id') + '"]').attr('class', 'unselectable morph_tree');
        break;

      case 'morph1':
        $('li.morph_tree[data-morph-1="' + skillObj.data('id') + '"]').attr('class', 'unselectable morph_tree morph_tree_up');
        break;

      case 'morph2':
        $('li.morph_tree[data-morph-2="' + skillObj.data('id') + '"]').attr('class', 'unselectable morph_tree morph_tree_down');
        break;
    }
  }
}

/**
 * Resets all skills to default.
 */
function resetPoints() {

  if(checkCanResetPoints() === true) {
    if(confirm(langArr['build_planer.reset_points_confirm']) === true) {

      resetSkills();
      resetActionBars();
      resetCP();
      resetSets();
      resetAttributes();

      requestBuildHash();

      shareBox.hide();
    }
  }
}

/**
 * Checks if any point can be reseted.
 *
 * @returns {boolean} Returns True if any point can be reseted otherwise False.
 */
function checkCanResetPoints() {

  let status = false;

  if(totalPoints > 0) {
    status = true;
  }
  else if(totalChampPoints > 0) {
    status = true;
  }
  else if(isSetPieceActive() === true) {
    status = true;
  }
  else if(attrHealth > 0 || attrMagicka > 0 || attrStamina > 0) {
    status = true;
  }
  else if(Object.keys(champSkills).length > 0) {
    status = true;
  }

  return status;
}

/**
 * Resets all skill points.
 */
function resetSkills() {

  let skillTempObj;

  for(let k in skills) {
    if(skills[k] > 0) {
      skillTempObj = $('img.skill_icon[data-id="' + k + '"]');
      skillTempObj.addData('points', skillTempObj.data('points-min'));

      if(skillTempObj.data('points-min') > 0) {
        skillTempObj.css('opacity', OPACITY_ACTIVE);
      }

      $('span.skill_icon_count[data-id="' + k + '"]').html(skillTempObj.data('points-min') + '/' + skillTempObj.data('points-max'));
    }
  }

  totalPoints = 0;
  skills = {};
  skillsActive = {};
  skillsUltimate = {};
  querySkills = {};

  // Always active skills
  for(let k in ALWAYS_ACTIVE_SKILLS) {
    skillsActive[k] = ALWAYS_ACTIVE_SKILLS[k];
  }

  passiveSkillList.children(':not(#passiveSkillListEmpty)').remove();
  passiveSkillListEmpty.show();

  $('li.morph_tree:not([data-no-parent-points])').attr('class', 'unselectable morph_tree morph_tree_disabled');
  $('li.morph_tree[data-no-parent-points]').attr('class', 'unselectable morph_tree');
  $('img.skill_icon[data-points-min="0"]').css('opacity', OPACITY_INACTIVE).addData('points', 0);
}

/**
 * Resets the action bars.
 */
function resetActionBars() {

  let actionBarTmpObj;

  for(let i = 1; i <= 2; i++) {
    for(let x = 1; x <= 6; x++) {
      actionBarTmpObj = $('#bar' + i + '_' + ((x === 6) ? 'r' : x));
      actionBarTmpObj.children('img.skill').attr('src', SLOT_EMPTY_DATA_IMAGE);
      actionBarTmpObj.children('img.slot').addData('id', '').addData('points', '');
    }
  }
}

/**
 * Resets the champion points.
 */
function resetCP() {

  for(let key in champPointsPerDiscipline) {
    champPointsPerDiscipline[key] = 0;
  }

  // Deactivate champion skills
  for(let key in champSkills) {
    $('li.champ_value[data-parent-id="' + key + '"]').html('0');
    $('img.champ_plus[data-parent-id="' + key + '"]').removeClass('off');
    $('img.champ_minus[data-parent-id="' + key + '"]').addClass('off');
  }

  // Remove active champion skills from top bar
  for(let slotIndex in champActiveSkills) {
    let skillId = champActiveSkills[slotIndex];
    $('[data-bar][data-skill-id="' + skillId + '"]').deleteData('skill-id').html('');
  }

  champSkills = {};
  champActiveSkills = {};
  totalChampPoints = 0;

  champTreePointsObj.html('0');
  setChampionSpentPoints();
  championDeactivateLinkedSkills();
  updateClusterTotalPoints();
}

/**
 * Resets the sets.
 */
function resetSets() {

  let obj;
  setSelect.each(function(k, v) {
    obj = $(v);
    obj.val('0').addData('current-value', 0).trigger('chosen:updated');
    onSetSelected(null, null, obj);
  });
}

/**
 * Resets the attributes.
 */
function resetAttributes() {

  attrHealth = 0;
  attrMagicka = 0;
  attrStamina = 0;

  setAttrPoints();
}

/**
 * Opens the skill overlay.
 *
 * @param {string} id The Id of the overlay.
 * @param {int} actionbar The number of the selected action bar.
 * @param {string} slot The action bar slot position.
 */
function openActionbarSkillOverlay(id, actionbar, slot) {

  if(overlayOpen === false) {

    let actionbarList = $('#overlaySkillsList');
    let skillItem = null;
    let skillCounter = 0;

    skillActionbar = actionbar;
    skillActionbarSlot = slot;

    actionbarList.children().remove();

    // Ultimate slot
    if(slot === 'r') {

      for(let k in skillsUltimate) {
        skillItem = $('img.skill_icon[data-id="' + k + '"], img.skill_icon_static[data-id="' + k + '"]');
        actionbarList.append('<li><img class="skill_icon_static" alt="" data-id="' + k + '" data-points="' + skillItem.data('points') + '" src="' + skillItem.data('icon') + '" onclick="setActionbarSlot(' + k + ', ' + skillItem.data('points') + ', \'' + skillItem.data('icon') + '\');" /></li>');
        skillCounter++;
      }
    }

    // Active Slot
    else {

      for(let k in skillsActive) {
        skillItem = $('img.skill_icon[data-id="' + k + '"], img.skill_icon_static[data-id="' + k + '"]');
        actionbarList.append('<li><img class="skill_icon_static" alt="" data-id="' + k + '" data-points="' + skillItem.data('points') + '" src="' + skillItem.data('icon') + '" onclick="setActionbarSlot(' + k + ', ' + skillItem.data('points') + ', \'' + skillItem.data('icon') + '\');" /></li>');
        skillCounter++;
      }
    }

    if(skillCounter === 0) {
      actionbarList.append('<li class="skill_list_empty green bold"><br/><i class="fa fa-info"></i> ' + langArr['build_planer.no_abilites_for_slot'] + '</li>');
    }

    openOverlay(id);
  }
}

/**
 * Sets the skill for the selected action bar slot.
 *
 * @param {string} id The skill Id.
 * @param {int} points The number of skill points.
 * @param {string} src The icon image path.
 */
function setActionbarSlot(id, points, src) {

  let actionBarSlotObj = $('#bar' + skillActionbar + '_' + skillActionbarSlot);

  actionBarSlotObj.children('img.skill').attr('src', src);
  actionBarSlotObj.children('img.slot').addData('id', id).addData('points', points);

  requestBuildHash();
}

/**
 * Removes the skill from the selected action bar slot.
 */
function unsetActionbarSlot() {

  let actionBarSlotObj = $('#bar' + skillActionbar + '_' + skillActionbarSlot);

  actionBarSlotObj.children('img.skill').attr('src', SLOT_EMPTY_DATA_IMAGE);
  actionBarSlotObj.children('img.slot').addData('id', '').addData('points', '');

  requestBuildHash();
}

/**
 * Adds the given skill to the list of passives.
 *
 * @param {object} skillObj The skill object.
 */
function addPassiveList(skillObj) {

  let passiveSkillObj = passiveSkillList.find('img[data-id="' + skillObj.data('id') + '"]');

  if(passiveSkillObj.length > 0) {
    // noinspection JSUnresolvedFunction
    passiveSkillObj.addData('points', skillObj.data('points'));
  }
  else {
    passiveSkillList.append('<li><img class="skill_icon_static skill_tooltip_trigger" alt="" data-id="' + skillObj.data('id') + '" data-race-skill="' + skillObj.data('race-skill') + '" data-class-skill="' + skillObj.data('class-skill') + '" data-points="' + skillObj.data('points') + '" src="' + skillObj.data('icon') + '" /></li>');
  }

  passiveSkillListEmpty.hide();
}

/**
 * Removes the given skill from the list of passives.
 *
 * @param {object} skillObj The skill object.
 */
function removePassiveList(skillObj) {

  passiveSkillList.find('img[data-id="' + skillObj.data('id') + '"]').parent().remove();

  // Check for 1 element, because one passive is alaway present
  if(passiveSkillList.children().length === 1) {
    passiveSkillListEmpty.show();
  }
}

/**
 * Adds or removes points from the given attribute HTML Id.
 *
 * @param {string} id The HTML Id of the attribute.
 */
function changeAttribute(id) {

  if(attributeSpeedup !== null) {
    clearTimeout(attributeSpeedup);
    attributeSpeedup = setTimeout(function() {
      changeAttribute(id);
    }, ATTRIBUTE_SPEEDUP_INTERVAL);
  }

  let totalAttrPoints = attrMagicka + attrHealth + attrStamina;

  switch(id) {

    case 'attrMagickaMinus':
      if(attrMagicka > 0) {
        attrMagicka--;
      }
      break;

    case 'attrMagickaPlus':
      if(totalAttrPoints < ATTRIBUTES_MAX_POINTS) {
        attrMagicka++;
      }
      break;

    case 'attrHealthMinus':
      if(attrHealth > 0) {
        attrHealth--;
      }
      break;

    case 'attrHealthPlus':
      if(totalAttrPoints < ATTRIBUTES_MAX_POINTS) {
        attrHealth++;
      }
      break;

    case 'attrStaminaMinus':
      if(attrStamina > 0) {
        attrStamina--;
      }
      break;

    case 'attrStaminaPlus':
      if(totalAttrPoints < ATTRIBUTES_MAX_POINTS) {
        attrStamina++;
      }
      break;
  }

  setAttrPoints();
  requestBuildHash();
}

/**
 * Loads the champion stars on click.
 */
function loadChampionPreviews() {

  let thisObj = null;

  $('img.champ_preview').each(function() {

    thisObj = $(this);

    if(thisObj.attr('src') === '') {
      thisObj.attr('src', thisObj.data('img'));
    }
  });
}

/**
 * Inits the active champion tree.
 *
 * @param	{number} id The Id of the champion tree.
 */
function initChampionTree(id) {

  // Hide tooltip
  tooltip.hide();
  tooltipVisible = false;

  panelChampionSystemFull.css('background-image', 'none');
  panelChampionSystemFull.show();
  panelChampionSystemPreview.hide();
  champLoadingObj.show();

  $('html, body').animate({ scrollTop: $('#champTop').offset().top }, 400);

  getChampionStars(id);
}

/**
 * Recives the champion star tree data from the server.
 *
 * @param {number} id The JavaScript Id of the tree.
 */
function getChampionStars(id) {

  if(championDisciplineXHR !== null) {
    championDisciplineXHR.abort();
  }

  removeChampionTree();

  championDisciplineXHR = $.ajax({
    type: 'POST',
    url: '/ajax/get_champion_discipline.php',
    data: { lang: lang, id: id }
  });

  championDisciplineXHR.done(function(json) {

    champCurrentDisciplineId = json.discipline_id;
    champCurrentParentDisciplineId = json.back_discipline_id;
    champPointsPerDiscipline[champCurrentDisciplineId] = 0;

    if(champCurrentParentDisciplineId !== null) {
      if(champPointsPerDiscipline.hasOwnProperty(champCurrentParentDisciplineId) === false) {
        champPointsPerDiscipline[champCurrentParentDisciplineId] = 0;
      }
    }

    panelChampionSystemFull.css('background-image', 'url(\'' + json.discipline_texture + '\')');
    champDisciplineName.html(json.discipline_name);
    champDisciplinePointsImg.attr('src', json.discipline_points_icon);
    champBack.addData('discipline-id', json.back_discipline_id);

    if(json.left_id === null) {
      champPrev.hide();
    }
    else {
      champPrev.addData('tree-id', json.left_id).show();
    }

    if(json.right_id === null) {
      champNext.hide();
    }
    else {
      champNext.addData('tree-id', json.right_id).show();
    }

    champDisciplineInfoPanel.show();
    champLinkedSkills = {};

    for(let key in json.stars) {
      createChampionStar(json.stars[key], json.discipline_star_icon, json.discipline_type);
    }

    if(json.cluster.length > 0) {
      for(let key in json.cluster) {
        createChampionCluster(json.cluster[key]);
      }
    }

    // Unlock linked stars
    for(let key in json.stars) {

      let starData = json.stars[key];
      let points = getChampionStarPoints(starData.id);

      championActivateLinkedSkills(starData.id, points, starData.has_jump_points, parseInt(starData.points_to_unlock));
    }

    setChampionSpentPoints();
  });

  championDisciplineXHR.always(function() {
    championDisciplineXHR = null;
    champLoadingObj.hide();
  });

  setChampionSpentPoints();
}

/**
 * Unlocks the linked skill Ids of the given skill.
 *
 * @param {number} id The Id of the champion skill.
 * @param {number} points The current spent points on the champion skill.
 * @param {boolean} jumpPointsEnabled If True jump points are enabled otherwise False.
 * @param {number|null} pointsToUnlock The first points count to unlock this skill.
 */
function championActivateLinkedSkills(id, points, jumpPointsEnabled, pointsToUnlock) {
  if((jumpPointsEnabled === true && points >= pointsToUnlock) || (jumpPointsEnabled === false && points > 0)) {
    if(typeof champLinkedSkills[id] !== 'undefined' && champLinkedSkills[id].length > 0) {
      for(let k in champLinkedSkills[id]) {
        let linkedSkillId = parseInt(champLinkedSkills[id][k]);
        $('div.champ_desc[data-parent-id="' + linkedSkillId + '"]').removeClass('hidden');
      }
    }
  }
}

/**
 * Checks every skill and deactivates the skills.
 */
function championDeactivateLinkedSkills() {

  champTempActiveSkills = {};
  champTempCheckedActiveSkills = {};

  $('img.champ_star[data-root-node="true"], img.champ_star[data-cluster-root="true"]').each(function(k, skillObj) {
    championBuildActiveSkillList(parseInt(skillObj.dataset.id));
  });

  $('img.champ_star').each(function(k, v) {

    let skillId = parseInt(v.dataset.id);

    if(champTempActiveSkills.hasOwnProperty(skillId) === false) {

      let numPoints = getChampionStarPoints(skillId);

      delete champSkills[skillId];

      champPointsPerDiscipline[champCurrentDisciplineId] -= numPoints;
      totalChampPoints -= numPoints;

      if(champCurrentParentDisciplineId !== null) {
        champPointsPerDiscipline[champCurrentParentDisciplineId] -= numPoints;
      }

      champTreePointsObj.html(champPointsPerDiscipline[champCurrentDisciplineId]);

      if(isChampionSkillInTopBar(skillId) === true) {
        removeChampionSkillFromTopBar(skillId);
      }

      // Update skill controls
      let skillDataObj = $('img.champ_star[data-root-node="false"][data-id="' + skillId + '"]');
      if(skillDataObj.length > 0) {
        skillDataObj.prop('draggable', false);
        $('div.champ_desc[data-parent-id="' + skillId + '"]').addClassOnce('hidden');
        $('li.champ_value[data-parent-id="' + skillId + '"]').html('0');
        $('img.champ_minus[data-parent-id="' + skillId + '"]').addClassOnce('off');
        $('img.champ_plus[data-parent-id="' + skillId + '"]').removeClass('off');
      }
    }
  });

  updateClusterTotalPoints();

  champTempActiveSkills = {};
  champTempCheckedActiveSkills = {};
}

/**
 * Builds the list of active skills.
 *
 * @param {number} skillId The current champion skill Id.
 */
function championBuildActiveSkillList(skillId) {

  if(champTempCheckedActiveSkills.hasOwnProperty(skillId) === false) {

    champTempCheckedActiveSkills[skillId] = 1;
    champTempActiveSkills[skillId] = 1;

    let links = (champLinkedSkills.hasOwnProperty(skillId) === true && Object.keys(champLinkedSkills[skillId]).length > 0) ? champLinkedSkills[skillId] : {};
    let points = getChampionStarPoints(skillId);
    let pointsToUnlock = getChampionStarPointsToUnlock(skillId);
    let jumpPointsEnabled = getChampionStarHasJumpPoints(skillId);

    if(typeof pointsToUnlock !== 'undefined' && links.length > 0) {
      if((jumpPointsEnabled === true && points >= pointsToUnlock) || (jumpPointsEnabled === false && points > 0)) {
        for(let linkedIndex in links) {
          championBuildActiveSkillList(links[linkedIndex]);
        }
      }
    }
  }
}

/**
 * Gets the current points of a champion star.
 *
 * @param {number} id The Id of the champion star.
 * @returns {number} Returns the number of points.
 */
function getChampionStarPoints(id) {
  return (typeof champSkills[id] !== 'undefined') ? parseInt(champSkills[id]) : 0;
}

/**
 * Gets the champion star max points.
 *
 * @param {number} id The champion skill Id.
 * @returns {number} Returns the champion star max points.
 */
function getChampionStarMaxPoints(id) {
  return (typeof champSkillData[id] !== 'undefined') ? parseInt(champSkillData[id].max_points) : 0;
}

/**
 * Gets the champion star points to unlock.
 *
 * @param {number} id The champion skill Id.
 * @returns {number} Returns the champion star points to unlock.
 */
function getChampionStarPointsToUnlock(id) {
  return (typeof champSkillData[id] !== 'undefined') ? parseInt(champSkillData[id].points_to_unlock) : 0;
}

/**
 * Gets the champion star has jump points status.
 *
 * @param {number} id The champion skill Id.
 * @returns {number} Returns the champion star has jump points status.
 */
function getChampionStarHasJumpPoints(id) {
  return (typeof champSkillData[id] !== 'undefined') ? champSkillData[id].has_jump_points : false;
}

/**
 * Gets the champion star jump points.
 *
 * @param {number} id The champion skill Id.
 * @returns {number} Returns the champion star jump points.
 */
function getChampionJumpPoints(id) {
  return (typeof champSkillData[id] !== 'undefined') ? champSkillData[id].jump_points : [];
}

/**
 * Gets the number of points to add based on the type and global max points.
 *
 * @param {number} points The current spent champion skill points.
 * @param {number} pointsMax The maximum points that can be spent on this champion skill.
 * @param {boolean} jumpPointsEnabled If True use the next greater jump point value.
 * @param {array} jumpPoints The array with the jump point values.
 * @returns {number} Returns the number of points to add based on the type and global max points.
 */
function getNumAddChampionPointsToNextUnlock(points, pointsMax, jumpPointsEnabled, jumpPoints) {

  let numPoints;

  // Set to zero if the number of max points has reached
  if(points >= pointsMax) {
    numPoints = 0;
  }

  // Get next jump points level
  else if(jumpPointsEnabled === true) {

    let nextUnlockPoints = 0;
    let numJumpPoints = jumpPoints.length - 1;

    for(let i = numJumpPoints; i >= 0; i--) {

      let jumpPoint = jumpPoints[i];

      if(points < jumpPoint) {
        nextUnlockPoints = jumpPoint;
      }
    }

    numPoints = nextUnlockPoints - points;
  }

  // Jump to max points for non jumping points
  else {
    numPoints = pointsMax - points;
  }

  // If the points exceed the max points limit, reduce points
  let champTotalPoints = getChampionTotalPointsCount() + numPoints;
  if(champTotalPoints > cpMaxPoints) {
    let numToMuchPoints = champTotalPoints - cpMaxPoints;
    numPoints -= numToMuchPoints;
  }

  return numPoints;
}

/**
 * Gets the number of points to remove based on the type and global max points.
 *
 * @param {number} points The current spent champion skill points.
 * @param {number} pointsMax The maximum points that can be spent on this champion skill.
 * @param {boolean} jumpPointsEnabled If True use the next greater jump point value.
 * @param {array} jumpPoints The array with the jump point values.
 * @returns {number} Returns the number of points to remove based on the type and global max points.
 */
function getNumRemoveChampionPointsToNextUnlock(points, pointsMax, jumpPointsEnabled, jumpPoints) {

  let numPoints;

  if(points <= 0) {
    numPoints = 0;
  }

  else if(jumpPointsEnabled === true) {

    let nextUnlockPoints = 0;
    let numJumpPoints = jumpPoints.length - 1;

    for(let i = 0; i <= numJumpPoints; i++) {

      let jumpPoint = jumpPoints[i];

      if(points > jumpPoint) {
        nextUnlockPoints = jumpPoint;
      }
    }

    numPoints = points - nextUnlockPoints;
  }

  else {

    if(points === pointsMax) {
      numPoints = pointsMax;
    }
    else {
      numPoints = points;
    }
  }

  return numPoints;
}

/**
 * Gets the champion star slotable status.
 *
 * @param {number} id The champion skill Id.
 * @returns {number} Returns the champion star slotable status.
 */
function getChampionStarSlotable(id) {
  return (typeof champSkillData[id] !== 'undefined') ? champSkillData[id].slotable : false;
}

/**
 * Gets the unlock status for champion cluster root skills.
 *
 * @param {array} linkedSkills An array with the linked skills.
 * @returns {boolean} Returns True if one of the linked skills is unlocked.
 */
function getChampionClusterRootUnlockStatus(linkedSkills) {

  let status = false;

  for(let i in linkedSkills) {

    let skillId = linkedSkills[i];
    let points = getChampionStarPoints(skillId);
    let pointsToUnlock = getChampionStarPointsToUnlock(skillId);

    if(pointsToUnlock > 0 && points >= pointsToUnlock) {
      status = true;
      break;
    }
  }

  return status;
}

/**
 * Adds the given star to the champion tree container.
 *
 * @param {object} starData An object containing the cp star data.
 * @param {string} starIcon The discipline star icon.
 * @param {number} disciplineType The discipline type value.
 */
function createChampionStar(starData, starIcon, disciplineType) {

  let startPoints = getChampionStarPoints(starData.id);
  let actionsY = (starData.y + CHAMP_STAR_ACTION_OFFSET_Y);
  let actionsX = (starData.x - CHAMP_STAR_ACTION_OFFSET_X);
  let unlockStatus = false;
  let dragableStatus = false;
  let dataBarType = '';

  champSkillData[starData.id] = starData;

  champPointsPerDiscipline[champCurrentDisciplineId] += startPoints;
  champLinkedSkills[starData.id] = starData.linked_skills;

  // -49 px to center star image
  starData.x = starData.x - CHAMP_STAR_OFFSET_X;
  starData.y = starData.y - CHAMP_STAR_OFFSET_Y;

  if(starData.cluster_root === true) {
    unlockStatus = getChampionClusterRootUnlockStatus(starData.linked_skills);
  }

  if(starData.slotable === true) {
    dataBarType = ' data-bar-type="' + disciplineType + '"';

    if(startPoints > 0) {
      dragableStatus = true;
    }
  }

  if (inputMode === INPUT_MODE_READONLY) {
    dragableStatus = false;
  }

  let html = '<img data-id="' + starData.id + '" data-root-node="' + starData.root_node + '" data-cluster-root="' + starData.cluster_root + '" ' + dataBarType + ' draggable="' + dragableStatus + '" class="champ_star cs_skill_tooltip_trigger unselectable" style="margin:' + starData.y + 'px 0 0 ' + starData.x + 'px;" src="' + starIcon + '">';
  let hidden = (starData.root_node === false && unlockStatus === false) ? ' hidden' : '';

  html += '<div class="champ_desc unselectable' + hidden + '" data-parent-id="' + starData.id + '" style="margin:' + actionsY + 'px 0 0 ' + actionsX + 'px;">';
  html += '	<ul class="champ_attr_actions">';
  html += '	  <li class="attr_minus">';

  if (inputMode !== INPUT_MODE_READONLY) {
    let disabled = (startPoints < 1) ? ' off' : '';
    html += '	<img class="champ_minus cs_skill_tooltip_trigger' + disabled + '" data-id="' + starData.id + '" data-parent-id="' + starData.id + '" draggable="false" src="/assets/images/layout/attr-remove.png" />';
  }

  html += '		</li>';
  html += '		<li data-parent-id="' + starData.id + '" class="attr_value champ_value">' + startPoints + '</li>';
  html += '		<li class="attr_plus">';

  if (inputMode !== INPUT_MODE_READONLY) {
    let disabled = (startPoints >= starData.max_points) ? ' off' : '';
    html += '	<img class="champ_plus cs_skill_tooltip_trigger' + disabled + '" data-id="' + starData.id + '" data-parent-id="' + starData.id + '" draggable="false" src="/assets/images/layout/attr-add.png" />';
  }

  html += '		</li>';
  html += ' </ul>';
  html += ' <div class="clear"></div>';
  html += '</div>';

  if(starData.connectors !== null) {

    let lines = '';

    for(let key in starData.connectors) {

      let con = starData.connectors[key];
      let from = con.from;
      let to = con.to;

      lines += '<div id="champ_line_' + from + '_' + to + '" class="champ_line"></div>';
    }

    if(lines !== '') {
      champConnectors.append(lines);
    }
  }

  panelChampionSystemFull.append(html);
}

/**
 * Adds the given champion cluster to the champion tree container.
 *
 * @param {object} clusterData An object containing the cp cluster data.
 */
function createChampionCluster(clusterData) {

  let clusterSkillIds = '';
  let hiddenSkillsHtml = '';

  // -49 px to center cluster image
  clusterData.x = clusterData.x - CHAMP_CLUSTER_OFFSET_X;
  clusterData.y = clusterData.y - CHAMP_CLUSTER_OFFSET_Y;

  // Cluster points position
  let clusterPointsX = clusterData.x + CHAMP_CLUSTER_POINTS_OFFSET_X;
  let clusterPointsY = clusterData.y + CHAMP_CLUSTER_POINTS_OFFSET_Y;

  if(clusterData.skills.length > 0) {
    for(let skillIndex in clusterData.skills) {

      let starData = clusterData.skills[skillIndex];
      let startPoints = getChampionStarPoints(starData.id);

      champPointsPerDiscipline[champCurrentDisciplineId] += startPoints;

      clusterSkillIds += ',' + starData.id;

      if(starData.cluster_root === 1) {
        champLinkedSkills[starData.id] = starData.linked_skills;
      }

      hiddenSkillsHtml += '<img data-id="' + starData.id + '" class="champ_star cluster_star unselectable" src="' + SLOT_EMPTY_DATA_IMAGE + '">';

      championActivateLinkedSkills(starData.id, startPoints, false, starData.points_to_unlock)
    }

    clusterSkillIds = clusterSkillIds.substring(1);
  }

  let clusterSkillPoints = 0;
  if(typeof champPointsPerDiscipline[clusterData.id] !== 'undefined') {
    clusterSkillPoints = champPointsPerDiscipline[clusterData.id];
  }

  let html = '<img data-cluster data-id="' + clusterData.id + '" data-cluster-skill-ids="' + clusterSkillIds + '" class="champ_cluster cs_cluster_skill_tooltip_trigger unselectable" style="margin:' + clusterData.y + 'px 0 0 ' + clusterData.x + 'px;" src="' + CHAMP_CLUSTER_ICON + '">';
  html += '<div class="champ_cluster_points" data-cluster-id="' + clusterData.id + '" style="margin:' + clusterPointsY + 'px 0 0 ' + clusterPointsX + 'px;">' + clusterSkillPoints + '</div>';

  panelChampionSystemFull.append(html + hiddenSkillsHtml);
}

/**
 * Removes the current active stars and descriptions.
 */
function removeChampionTree() {

  champDisciplineInfoPanel.hide();

  $('img.champ_star').each(function(key, value) {
    $('div.champ_desc[data-parent-id="' + $(this).data('id') + '"]').remove();
    $(value).remove();
  });

  $('img.champ_cluster').remove();
  $('div.champ_cluster_points').remove();
  champConnectors.children().remove();
}

/**
 * Adds a champion star point.
 *
 * @param {object} obj The object of the star.
 * @param {boolean} speedup If True the speedup function is triggered.
 * @param {boolean} jumpToNextUnlock If True the points until next unlock are added.
 */
function addChampionPoint(obj, speedup, jumpToNextUnlock) {

  if(champSpeedup !== null) {
    clearTimeout(champSpeedup);

    if(speedup === true) {
      champSpeedup = setTimeout(function() {
        addChampionPoint(obj, speedup, jumpToNextUnlock);
      }, CHAMP_SPEEDUP_INTERVAL);
    }
  }

  let starID = parseInt(obj.data('parent-id'));
  let points = getChampionStarPoints(starID);
  let pointsMax = getChampionStarMaxPoints(starID);
  let jumpPointsEnabled = getChampionStarHasJumpPoints(starID);
  let slotable = getChampionStarSlotable(starID);
  let pointsToUnlock = getChampionStarPointsToUnlock(starID);
  let spentPoints = 1;

  if(jumpToNextUnlock === true) {
    let jumpPoints = getChampionJumpPoints(starID);
    spentPoints = getNumAddChampionPointsToNextUnlock(points, pointsMax, jumpPointsEnabled, jumpPoints);
  }

  points += spentPoints;

  if(points <= pointsMax && getChampionTotalPointsCount() < cpMaxPoints) {

    champSkills[starID] = points;

    champPointsPerDiscipline[champCurrentDisciplineId] += spentPoints;
    totalChampPoints += spentPoints;

    if(champCurrentParentDisciplineId !== null) {
      champPointsPerDiscipline[champCurrentParentDisciplineId] += spentPoints;
    }

    getTooltip(starID, points, CHAMP_TOOLTIP_TYPE_CHAMPION, true);

    champTreePointsObj.html(champPointsPerDiscipline[champCurrentDisciplineId]);

    $('li.champ_value[data-parent-id="' + starID + '"]').html(points.toString());
    $('img.champ_minus[data-parent-id="' + starID + '"]').removeClass('off');

    if(points >= pointsMax) {
      $('img.champ_plus[data-parent-id="' + starID + '"]').addClass('off');
    }

    if(slotable === true) {
      checkChampionSkillIsInTopBar(starID, points, pointsToUnlock);
    }

    championActivateLinkedSkills(starID, points, jumpPointsEnabled, pointsToUnlock);
  }

  setChampionSpentPoints();
  requestBuildHash();
}

/**
 * Removes a champion star point.
 *
 * @param {object} obj The object of the star.
 * @param {boolean} speedup If True the speedup function is triggered.
 * @param {boolean} jumpToNextUnlock If True the points until next unlock are added.
 */
function removeChampionPoint(obj, speedup, jumpToNextUnlock) {

  if(champSpeedup !== null) {
    clearTimeout(champSpeedup);

    if(speedup === true) {
      champSpeedup = setTimeout(function() {
        removeChampionPoint(obj, speedup, jumpToNextUnlock);
      }, CHAMP_SPEEDUP_INTERVAL);
    }
  }

  let starID = obj.data('parent-id');
  let points = getChampionStarPoints(starID);
  let pointsMax = getChampionStarMaxPoints(starID);
  let slotable = getChampionStarSlotable(starID);
  let pointsToUnlock = getChampionStarPointsToUnlock(starID);
  let recudePoints = 1;

  if(jumpToNextUnlock === true) {
    let jumpPointsEnabled = getChampionStarHasJumpPoints(starID);
    let jumpPoints = getChampionJumpPoints(starID);
    recudePoints = getNumRemoveChampionPointsToNextUnlock(points, pointsMax, jumpPointsEnabled, jumpPoints);
  }

  points -= recudePoints;

  if(points >= 0) {

    champPointsPerDiscipline[champCurrentDisciplineId] -= recudePoints;
    totalChampPoints -= recudePoints;

    if(champCurrentParentDisciplineId !== null) {
      champPointsPerDiscipline[champCurrentParentDisciplineId] -= recudePoints;
    }

    champTreePointsObj.html(champPointsPerDiscipline[champCurrentDisciplineId]);

    getTooltip(starID, points, CHAMP_TOOLTIP_TYPE_CHAMPION, true);

    if(points > 0) {
      $('img.champ_minus[data-parent-id="' + starID + '"]').removeClass('off');
    }

    if(points < pointsMax) {
      $('img.champ_plus[data-parent-id="' + starID + '"]').removeClass('off');
    }

    $('li.champ_value[data-parent-id="' + starID + '"]').html(points.toString());

    if(points === 0) {
      $('img.champ_minus[data-parent-id="' + starID + '"]').addClass('off');
      delete champSkills[starID];
    }
    else {
      champSkills[starID] = points;
    }

    if(slotable === true) {
      checkChampionSkillIsInTopBar(starID, points, pointsToUnlock);
    }

    championDeactivateLinkedSkills();
  }

  setChampionSpentPoints();
  requestBuildHash();
}

/**
 * Checks if the skill is unlocked, draggable and when it's no longer draggable if it should get removed fro mthe top bar.
 *
 * @param {number} id Zhe champion skill Id.
 * @param {number} points The spent skill points.
 * @param {number} pointsToUnlock The required skill points to unlock this skill.
 */
function checkChampionSkillIsInTopBar(id, points, pointsToUnlock) {

  let draggable = (points >= pointsToUnlock);
  if(draggable === false) {

    let slot = $('[data-bar][data-skill-id="' + id + '"]');
    if(slot.length > 0) {
      slot.each(function(k, v) {
        removeChampionSkillFromTopBar(parseInt(v.dataset.skillId));
      });
    }
  }

  if(inputMode === INPUT_MODE_READONLY) {
    draggable = false;
  }

  $('img.champ_star[data-id="' + id + '"]').prop('draggable', draggable);
}

/**
 * Checks if the champion champion skill is in the top bar.
 *
 * @param {number} skillId The skill Id.
 * @returns {boolean} Returns True if the champion skill is in the top bar otherwise False.
 */
function isChampionSkillInTopBar(skillId) {
  return ($('[data-bar][data-skill-id="' + skillId + '"]').length > 0);
}

/**
 * Removes the champion skill from the top bar.
 *
 * @param {number} skillId The skill Id.
 */
function removeChampionSkillFromTopBar(skillId) {

  let slot = $('[data-bar][data-skill-id="' + skillId + '"]');
  slot.html('');
  slot.deleteData('skill-id');
  delete champActiveSkills[slot.data('bar')];
}

/**
 * Gets the total amount of champion points.
 *
 * @returns {object} Returns the total amount of champion points.
 */
function getChampionTotalPoints() {
  return {
    green: (champPointsPerDiscipline.hasOwnProperty(CHAMP_DISCIPLINE_GREEN_ID) === true) ? champPointsPerDiscipline[CHAMP_DISCIPLINE_GREEN_ID] : 0,
    blue: (champPointsPerDiscipline.hasOwnProperty(CHAMP_DISCIPLINE_BLUE_ID) === true) ? champPointsPerDiscipline[CHAMP_DISCIPLINE_BLUE_ID] : 0,
    red: (champPointsPerDiscipline.hasOwnProperty(CHAMP_DISCIPLINE_RED_ID) === true) ? champPointsPerDiscipline[CHAMP_DISCIPLINE_RED_ID] : 0,
  };
}

/**
 * Gets the total amount of spent champion points.
 *
 * @returns {number} Returns the total amount of spent champion points.
 */
function getChampionTotalPointsCount() {
  let champTotalPoints = getChampionTotalPoints();
  return champTotalPoints.green + champTotalPoints.blue + champTotalPoints.red;
}

/**
 * Sets the spent champion points.
 */
function setChampionSpentPoints() {

  let championTotalPoints = getChampionTotalPoints();
  let champTotalPoints = championTotalPoints.green + championTotalPoints.blue + championTotalPoints.red;

  $('[data-cp-points-discipline-id="' + CHAMP_DISCIPLINE_GREEN_ID + '"]').html(championTotalPoints.green.toString());
  $('[data-cp-points-discipline-id="' + CHAMP_DISCIPLINE_BLUE_ID + '"]').html(championTotalPoints.blue.toString());
  $('[data-cp-points-discipline-id="' + CHAMP_DISCIPLINE_RED_ID + '"]').html(championTotalPoints.red.toString());
  $('#champTreeOverview' + CHAMP_DISCIPLINE_GREEN_ID).html(championTotalPoints.green.toString());
  $('#champTreeOverview' + CHAMP_DISCIPLINE_BLUE_ID).html(championTotalPoints.blue.toString());
  $('#champTreeOverview' + CHAMP_DISCIPLINE_RED_ID).html(championTotalPoints.red.toString());
  $('#champPointsTotal').html(champTotalPoints.toString());
  $('#totalChampionPoints').html(champTotalPoints.toString());

  if(champPointsPerDiscipline.hasOwnProperty(champCurrentDisciplineId) === true) {
    $('#champDisciplinePointsCount').html(champPointsPerDiscipline[champCurrentDisciplineId]);
  }
}

/**
 * Updates the champion cluster points.
 */
function updateClusterTotalPoints() {

  $('[data-cluster]').each(function(k, v) {

    let clusterTotalPoints = 0;
    let skillIDList = v.dataset.clusterSkillIds.split(',');

    for(let k in skillIDList) {
      let skillID = parseInt(skillIDList[k]);
      if (champSkills.hasOwnProperty(skillID) === true) {
        clusterTotalPoints += champSkills[skillID];
      }
    }

    $('[data-cluster-id="' + v.dataset.id + '"]').html(clusterTotalPoints.toString());
  });
}

/**
 * Show skill descriptions.
 */
function showSkillDescription() {
  tabSkills.trigger('click');
  skillTreeName.html(skillTreeName.data('text-default-title'));
  $('#skillInfoText').show();
  $('div.ultimate').hide();
  $('div.active').hide();
  $('div.passive').hide();
}
